import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Breadcrumb from './Breadcrumb';

const Header = () => {
    const navigate = useNavigate(); // Add this hook
    const [dsaPopupType, setDsaPopupType] = useState(''); // 'success' or 'error'
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const [dsaPopupMessage, setDsaPopupMessage] = useState('');
    const [currentLanguage, setCurrentLanguage] = useState('english');
    const [isDSAFormOpen, setIsDSAFormOpen] = useState(false);
    const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
    const [dsaStep, setDsaStep] = useState(1); // 1: Personal, 2: Professional, 3: Documents
    const [showDsaPopup, setShowDsaPopup] = useState(false);
    const [selfiePhoto, setSelfiePhoto] = useState(null);
    const [aadhaarFront, setAadhaarFront] = useState(null);
    const [aadhaarBack, setAadhaarBack] = useState(null);
    const [panCardPhoto, setPanCardPhoto] = useState(null);
    const [cancelCheque, setCancelCheque] = useState(null);
    const [officePhoto, setOfficePhoto] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [otherDocuments, setOtherDocuments] = useState([{ text: '', file: null, name: '', size: 0, type: '' }]);
    const [gender, setGender] = useState('');
    const [selfiePreviewUrl, setSelfiePreviewUrl] = useState('');
    const [officePreviewUrl, setOfficePreviewUrl] = useState('');
    const [isLoadingLocation, setIsLoadingLocation] = useState(false);
    const [dsaSubmitMessage, setDsaSubmitMessage] = useState('');
    const [dsaSubmitStatus, setDsaSubmitStatus] = useState('');


    useEffect(() => {
        const interval = setInterval(() => {
            const select = document.querySelector(".goog-te-combo");
            if (select) {
                clearInterval(interval);
            }
        }, 500);
    }, []);

    const changeLanguage = (lang) => {
        const select = document.querySelector(".goog-te-combo");
        if (select) {
            select.value = lang;
            select.dispatchEvent(new Event("change"));
        }
        setCurrentLanguage(lang);
        setIsLanguageMenuOpen(false);
    };

    const handleGenderChange = (value) => {
        setDsaForm(prev => ({ ...prev, gender: value }));
        setGender(value);
    };

    // Handle pincode blur (when user leaves the field)
    const handlePincodeBlur = async (e) => {
        const pincode = e.target.value.trim();

        if (pincode.length === 6) {
            await fetchLocationFromPincode(pincode);
        }
    };

    // Fetch location data from pincode
    const fetchLocationFromPincode = async (pincode) => {
        if (!pincode || pincode.length !== 6) return;

        setIsLoadingLocation(true);

        try {
            // Using India Post API (free and reliable)
            const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
            const data = await response.json();

            if (data[0].Status === "Success") {
                const postOffice = data[0].PostOffice[0];

                setDsaForm(prev => ({
                    ...prev,
                    city: postOffice.District || postOffice.Name,
                    state: postOffice.State,
                    area: postOffice.Name
                }));

            } else {
                // Fallback to manual entry
                setDsaForm(prev => ({
                    ...prev,
                    city: '',
                    state: '',
                    area: ''
                }));

                // Show message to enter manually
                alert('Pincode not found. Please enter city and state manually.');
            }
        } catch (error) {
            console.error('Error fetching pincode data:', error);

            // Alternative API fallback
            try {
                const fallbackResponse = await fetch(`https://api.zippopotam.us/in/${pincode}`);
                const fallbackData = await fallbackResponse.json();

                if (fallbackData.places && fallbackData.places.length > 0) {
                    const place = fallbackData.places[0];

                    setDsaForm(prev => ({
                        ...prev,
                        city: place['place name'],
                        state: place.state
                    }));
                }
            } catch (fallbackError) {
                console.error('Fallback API also failed:', fallbackError);

                // Show message to enter manually
                alert('Unable to fetch location. Please enter city and state manually.');
            }
        } finally {
            setIsLoadingLocation(false);
        }
    };

    const submitStep1 = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL || 'https://kfs09.in/api';

            const formData = new FormData();
            formData.append('full_name', dsaForm.fullname);
            formData.append('pan_number', dsaForm.pan);
            formData.append('date_of_birth', dsaForm.dob);
            formData.append('email', dsaForm.email);
            formData.append('mobile_number', dsaForm.mobile);
            formData.append('gender', dsaForm.gender.toLowerCase());
            formData.append('aadhar_number', dsaForm.aadhaar_number);
            formData.append('address', dsaForm.address);
            formData.append('pincode', dsaForm.pincode);
            formData.append('city', dsaForm.city);
            formData.append('area_locality', dsaForm.area);
            formData.append('state', dsaForm.state);

            const response = await fetch(`${apiUrl}/v1/partner/step1`, {
                method: 'POST',
                body: formData
            });

            const result = await response.json();

            if (response.ok) {
                if (result.data && result.data.user_id) {
                    localStorage.setItem('dsa_user_id', result.data.user_id);
                }
                console.log('Step 1 submitted successfully:', result);
                return result;
            } else {
                // Extract detailed error messages from backend
                let errorMessage = 'Step 1 submission failed';

                if (result.errors) {
                    // Use the helper function to format errors
                    errorMessage = formatBackendErrors(result.errors);
                } else if (result.message) {
                    errorMessage = result.message;
                }

                throw new Error(errorMessage);
            }
        } catch (error) {
            console.error('Error submitting Step 1:', error);
            throw error; // Re-throw to be caught by goToNextStep
        }
    };

    const submitStep2 = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL || 'https://kfs09.in/api';
            const userId = localStorage.getItem('dsa_user_id');

            if (!userId) {
                throw new Error('User ID not found. Please complete Step 1 first.');
            }

            const formData = new FormData();
            formData.append('user_id', userId);
            formData.append('experience_years', dsaForm.experience);
            formData.append('current_profession', dsaForm.profession);

            if (selfiePhoto) {
                formData.append('selfie_photo', selfiePhoto);
            }
            if (officePhoto) {
                formData.append('office_photo', officePhoto);
            }

            const response = await fetch(`${apiUrl}/v1/partner/step2`, {
                method: 'POST',
                body: formData
            });

            const result = await response.json();

            if (response.ok) {
                console.log('Step 2 submitted successfully:', result);
                return result;
            } else {
                // Extract detailed error messages from backend
                let errorMessage = 'Step 2 submission failed';

                if (result.errors) {
                    // Use the helper function to format errors
                    errorMessage = formatBackendErrors(result.errors);
                } else if (result.message) {
                    errorMessage = result.message;
                }

                throw new Error(errorMessage);
            }
        } catch (error) {
            console.error('Error submitting Step 2:', error);
            throw error; // Re-throw to be caught by goToNextStep
        }
    };

    // Add this function to capture selfie
    const captureSelfie = (setter) => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: 'user',
                    width: { ideal: 1280 },
                    height: { ideal: 720 }
                },
                audio: false
            })
                .then((stream) => {
                    const video = document.createElement('video');
                    video.srcObject = stream;
                    video.play();

                    const cameraModal = document.createElement('div');
                    cameraModal.className = 'camera-modal';
                    cameraModal.innerHTML = `
        <div class="camera-modal-content">
          <div class="camera-header">
            <h3>Take Selfie</h3>
            <button class="close-camera">&times;</button>
          </div>
          <div class="camera-feed">
            <video id="cameraView" autoplay playsinline></video>
          </div>
          <div class="camera-controls">
            <button id="captureBtn" class="capture-btn">📸 Capture</button>
            <button id="retakeBtn" class="retake-btn" style="display:none;">🔄 Retake</button>
          </div>
        </div>
      `;

                    document.body.appendChild(cameraModal);
                    const videoElement = cameraModal.querySelector('#cameraView');
                    videoElement.srcObject = stream;

                    cameraModal.querySelector('#captureBtn').onclick = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = videoElement.videoWidth;
                        canvas.height = videoElement.videoHeight;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(videoElement, 0, 0);

                        // Create preview URL
                        const previewUrl = canvas.toDataURL('image/jpeg', 0.9);
                        setSelfiePreviewUrl(previewUrl);

                        canvas.toBlob((blob) => {
                            const file = new File([blob], `selfie_${Date.now()}.jpg`, {
                                type: 'image/jpeg',
                                lastModified: Date.now()
                            });

                            // Set the file
                            if (setter) {
                                setter(file);
                            } else {
                                setSelfiePhoto(file);
                            }

                            // Stop camera and remove modal
                            stream.getTracks().forEach(track => track.stop());
                            cameraModal.remove();

                        }, 'image/jpeg', 0.9);
                    };

                    cameraModal.querySelector('.close-camera').onclick = () => {
                        stream.getTracks().forEach(track => track.stop());
                        cameraModal.remove();
                    };
                })
                .catch((error) => {
                    alert('Camera access denied. Please allow camera permission to take a selfie.');
                    console.error('Camera error:', error);

                    // Fallback to file upload
                    const fileInput = document.createElement('input');
                    fileInput.type = 'file';
                    fileInput.accept = 'image/*';
                    fileInput.onchange = (e) => {
                        if (e.target.files && e.target.files[0]) {
                            const file = e.target.files[0];
                            if (setter) {
                                setter(file);
                            } else {
                                setSelfiePhoto(file);
                            }

                            // Create preview for uploaded file
                            const reader = new FileReader();
                            reader.onload = (event) => {
                                setSelfiePreviewUrl(event.target.result);
                            };
                            reader.readAsDataURL(file);
                        }
                    };
                    fileInput.click();
                });
        } else {
            alert('Camera not available on this device. Please upload a photo instead.');

            // Fallback to file upload
            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = 'image/*';
            fileInput.onchange = (e) => {
                if (e.target.files && e.target.files[0]) {
                    const file = e.target.files[0];
                    if (setter) {
                        setter(file);
                    } else {
                        setSelfiePhoto(file);
                    }

                    // Create preview for uploaded file
                    const reader = new FileReader();
                    reader.onload = (event) => {
                        setSelfiePreviewUrl(event.target.result);
                    };
                    reader.readAsDataURL(file);
                }
            };
            fileInput.click();
        }
    };

    // File upload handlers
    const handleFileUpload = (setter, file, maxSizeMB = 5, type = 'general') => {
        if (!file) return;

        const maxSize = maxSizeMB * 1024 * 1024; // Convert MB to bytes

        if (file.size > maxSize) {
            alert(`File size must be less than ${maxSizeMB}MB`);
            return;
        }

        // Validate file types
        const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
        const allowedPdfTypes = ['application/pdf'];
        const allowedTypes = [...allowedImageTypes, ...allowedPdfTypes];

        if (!allowedTypes.includes(file.type)) {
            alert('Please upload only JPG, PNG, or PDF files');
            return;
        }

        setter(file);

        // Create preview for images
        if (file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = (e) => {
                if (setter === setSelfiePhoto) {
                    setSelfiePreviewUrl(e.target.result);
                } else if (setter === setOfficePhoto) {
                    setOfficePreviewUrl(e.target.result);
                } else if (setter === setAadhaarFront) {
                    // You can add more preview states for other documents if needed
                    console.log('Aadhaar front uploaded');
                }
                // Add more conditions for other document types if needed
            };
            reader.readAsDataURL(file);
        }
    };

    const addOtherDocumentField = () => {
        setOtherDocuments([...otherDocuments, {
            text: '',
            file: null,
            name: '',
            size: 0,
            type: 'other'
        }]);
    };

    const removeOtherDocumentField = (index) => {
        if (otherDocuments.length > 1) {
            const updatedDocs = otherDocuments.filter((_, i) => i !== index);
            setOtherDocuments(updatedDocs);
        }
    };

    // Function to go to previous step
    const goToPrevStep = () => {
        setDsaStep(prev => prev - 1);
    };

    // Updated goToNextStep function with popup error handling
    const goToNextStep = async () => {
        if (validateCurrentStep()) {
            try {
                // Call step API based on current step
                if (dsaStep === 1) {
                    await submitStep1();
                } else if (dsaStep === 2) {
                    await submitStep2();
                }

                // Move to next step only if API call is successful
                setDsaStep(prev => prev + 1);
            } catch (error) {
                // Show error in popup instead of console
                const errorMessage = error.message || 'An error occurred. Please try again.';
                setDsaPopupMessage(errorMessage);
                setDsaPopupType('error');
                setShowDsaPopup(true);

                // Auto-hide after 5 seconds
                setTimeout(() => {
                    setShowDsaPopup(false);
                }, 5000);
            }
        }
    };

    const handlePincodeChange = (e) => {
        const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
        handleDsaInputChange('pincode', value);

        // Clear city and state if pincode is less than 6 digits
        if (value.length < 6) {
            setDsaForm(prev => ({
                ...prev,
                city: '',
                state: ''
            }));
        }
    };

    const handleDsaInputChange = (field, value) => {
        setDsaForm(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const [dsaForm, setDsaForm] = useState({
        fullname: '',
        pan: '',
        dob: '',
        email: '',
        mobile: '',
        gender: '',
        aadhaar_number: '',
        address: '',
        pincode: '',
        city: '',
        state: '',
        area: '',
        experience: '',
        profession: '',
        // Nominee fields removed as per request
    });

    // const translations = {
    //     english: {
    //         logo: 'FinLink',
    //         navHome: 'Home',
    //         navServices: 'Services',
    //         navAbout: 'About us',
    //         navDsa: 'Become Partner',

    //         navFaq: 'FAQ',
    //         navContact: 'Contact',
    //         navCareer: 'Career with us',
    //         navHelp: 'Help Desk',
    //         partnerButton: 'Login',
    //         applyButton: 'Become DSA',

    //         heroTitleLine1: "India's Leading Loan",
    //         heroTitleLine2: "Financial Services Platform",
    //         heroDescription: 'Connect with 100+ banking partners for Home Loans, Personal Loans, Business Loans, Credit Cards, Insurance and more. Get best rates with instant eligibility check and digital document submission.',
    //         exploreButton: 'Check Eligibility',
    //         cibilButton: 'Check CIBIL Score',


    //         statExpText: 'Years Experience',
    //         statPartnersText: 'Banking Partners',
    //         statCitiesText: 'Freelancers',
    //         statLoansText: 'Satiesfied Customer',

    //         productsTitle: 'We Make a Wide Range of Financial Products Affordable',
    //         productsSubtitle: 'That suits your client needs! Choose from our comprehensive financial solutions',

    //         product1Title: 'Home Loan',
    //         product1Desc: 'Your dream home awaits - Explore our range of home loan products with flexible options.',
    //         product1Feature1: 'Lowest interest rates starting from 8.5%',
    //         product1Feature2: 'Up to 90% of property value',
    //         product1Feature3: 'Long tenure up to 30 years',
    //         product1Button: 'Check Eligibility',

    //         product2Title: 'Personal Loan',
    //         product2Desc: 'Achieve your dreams with our versatile personal loan options for all needs.',
    //         product2Feature1: 'Up to ₹40 Lakhs amount',
    //         product2Feature2: 'Instant approval in 24 hours',
    //         product2Feature3: 'No collateral required',
    //         product2Button: 'Become DSA',

    //         product3Title: 'Loan Against Property',
    //         product3Desc: 'Unlock your property value with ready-made loan solutions at attractive rates.',
    //         product3Feature1: 'High value loans available',
    //         product3Feature2: 'Lowest interest rates',
    //         product3Feature3: 'Flexible repayment options',
    //         product3Button: 'Get Offers',

    //         product4Title: 'Business Loan',
    //         product4Desc: 'Accelerate your business growth with our flexible financing options and quick disbursal.',
    //         product4Feature1: 'Up to ₹2 Crore',
    //         product4Feature2: 'Minimal documentation',
    //         product4Feature3: 'Collateral-free options',
    //         product4Button: 'Boost Business',

    //         product5Title: 'Car Loan',
    //         product5Desc: 'Drive your dream car with our quick and flexible car loans for new and used vehicles.',
    //         product5Feature1: '100% on-road funding',
    //         product5Feature2: 'Competitive interest rates',
    //         product5Feature3: 'Fast processing',
    //         product5Button: 'Check Offers',

    //         product6Title: 'Education Loan',
    //         product6Desc: 'Invest in your child\'s future with our special education loans for domestic studies.',
    //         product6Feature1: 'Covers tuition + living expenses',
    //         product6Feature2: 'Moratorium period available',
    //         product6Feature3: 'Tax benefits under Sec 80E',
    //         product6Button: 'Apply for Loan',

    //         insuranceTitle: 'Wide Range of Insurance Products',
    //         insuranceSubtitle: 'Protect what matters most with our comprehensive insurance solutions',
    //         insurance1Title: 'Life Insurance',
    //         insurance1Desc: 'Secure your loved ones future with reliable life insurance plans.',
    //         insurance1Price: 'Starting at ₹450/month*',
    //         insurance1Button: 'Get Quote',

    //         insurance2Title: 'Health Insurance',
    //         insurance2Desc: 'Ensuring your health is in good hands with best coverage.',
    //         insurance2Price: 'Starting at ₹450/month*',
    //         insurance2Button: 'Compare Plans',

    //         insurance3Title: 'General Insurance',
    //         insurance3Desc: 'Insurance made easy - Your protection for vehicles and more, our expertise.',
    //         insurance3Price: 'Starting at ₹450/month*',
    //         insurance3Button: 'Explore Now',

    //         processTitle: 'Easy. Convenient. Fast.',
    //         processSubtitle: 'Simple and quick steps for your loan with 90% success rate',
    //         step1Title: 'Check Eligibility',
    //         step1Desc: 'Tell us your need. Our AI matches with best banks based on 90+ criteria.',
    //         step2Title: 'Compare Offers',
    //         step2Desc: 'View personalized loan options side by side from 100+ lenders.',
    //         step3Title: 'Apply Digitally',
    //         step3Desc: 'Complete application and submit documents directly to selected banks.',
    //         step4Title: 'Get Disbursal',
    //         step4Desc: 'Get quick approval and disbursal in hours not weeks.',

    //         dsaTitle: 'Become DSA Partner',
    //         dsaSubtitle: 'Join India\'s fastest growing loan distribution network and start earning attractive commissions',
    //         dsaDescription: 'Loan Agents, Ex-Bankers, Financial Analysts, Insurance Agents, Mutual Fund Agents, Chartered Accountants, Builders or professionals from any field can partner with us.',
    //         benefit1Title: 'Attractive Commissions',
    //         benefit1Desc: 'Earn competitive commissions on every successful loan disbursal.',
    //         benefit2Title: 'Comprehensive Training',
    //         benefit2Desc: 'Get detailed training on products, processes and sales techniques.',
    //         benefit3Title: 'Dedicated Support',
    //         benefit3Desc: '24/7 support team to assist you and your clients throughout the process.',
    //         dsaButton: 'Register as Partner',

    //         teamTitle: 'Our Team',
    //         teamMembers: [
    //             {
    //                 name: 'Mr Rakesh Panchal',
    //                 position: 'FOUNDER',
    //                 photo: '/avatars/ceo.png'  // Adjust filename if needed, based on your avatars folder
    //             },
    //             {
    //                 name: 'Lauren Pybus',
    //                 position: 'VP Growth & Development',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Raelen Thomas',
    //                 position: 'VP Finance Operations',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Mitchell Fawcett',
    //                 position: 'VP Strategy',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Jieu Segal',
    //                 position: 'VP Sales & Marketing',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Darren Maher',
    //                 position: 'Creative Director',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Ben Van Exan',
    //                 position: 'Snr Account Executive',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'John Blown',
    //                 position: 'Founding Partner',
    //                 photo: '/avatars/amit.png'
    //             },
    //         ],



    //         faqTitle: 'Frequently Asked Questions',
    //         faqSubtitle: 'Find answers to common questions about our services and processes',
    //         faq1Question: 'What is Krishna Finconcept Services and how does it work?',
    //         faq1Answer: 'Krishna Finconcept Services Is A Comprehensive Financial Services Platform That Connects Customers With 100+ Banking Partners For Loans, Credit Cards And Insurance. We Use AI To Match You With Best Offers, Help With Eligibility Check And Facilitate Digital Document Submission.',
    //         faq2Question: 'Is my personal and financial information secure?',
    //         faq2Answer: 'Yes, We Follow Strict Security Protocols And Comply With All Data Protection Regulations. We Never Store Your Bank Login Credentials And Share Information With Lenders Only With Your Explicit Consent For Processing Your Application.',
    //         faq3Question: 'How can I become a DSA partner?',
    //         faq3Answer: 'Any Individual Above 25 Years With PAN And Aadhaar Can Become A Partner. Professionals From Finance, Real Estate, Insurance Or Any Field Can Join. We Provide Complete Training, Marketing Support And Timely Commission Payments.',
    //         faq4Question: 'Do you support all Indian banks?',
    //         faq4Answer: 'We Partner With 100+ Major Banks And NBFCs Including HDFC, ICICI, SBI, Axis, Kotak, Bajaj Finserv And Many More. While We Don\'t Cover Every Single Bank, We Work With All Major Financial Institutions In India.',





    //         // New Testimonials
    //         testimonialTitle: 'What Our Customers Say',
    //         testimonialSubtitle: 'Hear from our satisfied clients about their experience with Krishna Finconcept Services',
    //         testimonials: [
    //             {
    //                 name: 'Amit Sharma',
    //                 photo: '/avatars/amit.png',
    //                 rating: 5,
    //                 text: 'Krishna Finconcept Services made getting my home loan so easy! Excellent service and quick approval.'
    //             },
    //             {
    //                 name: 'Priya Patel',
    //                 photo: '/avatars/priya.png',
    //                 rating: 5,
    //                 text: 'Great platform with multiple options. Found the best interest rate for my personal loan.'
    //             },
    //             {
    //                 name: 'Rahul Verma',
    //                 photo: '/avatars/rahul.png',
    //                 rating: 4,
    //                 text: 'As a DSA partner, Krishna Finconcept Services has boosted my earnings with timely commissions and great support.'
    //             },
    //             {
    //                 name: 'Sneha Gupta',
    //                 photo: '/avatars/sneha.png',
    //                 rating: 5,
    //                 text: 'Quick and hassle-free health insurance. Saved a lot compared to direct purchase!'
    //             },
    //             {
    //                 name: 'Vikram Singh',
    //                 photo: '/avatars/amit.png',
    //                 rating: 5,
    //                 text: 'User-friendly EMI calculator and seamless business loan application process.'
    //             }
    //         ],



    //         partnersTitle: 'Our Banking Partners',
    //         partnersSubtitle: 'Trusted by India\'s Leading Financial Institutions',

    //         footerAbout: 'Krishna Finconcept Services',
    //         footerDescription: 'India\'s leading financial services platform, connecting customers with 100+ banking partners for loans, credit cards, insurance and investment products.',
    //         footerProducts: 'Loan Products',
    //         footerHome: 'Home Loan',
    //         footerPersonal: 'Personal Loan',
    //         footerBusiness: 'Business Loan',
    //         footerLap: 'Loan Against Property',
    //         footerCar: 'Car Loan',
    //         footerEducation: 'Education Loan',
    //         footerServices: 'Other Services',
    //         footerCredit: 'Credit Cards',
    //         footerInsurance: 'Insurance',
    //         footerGold: 'Gold Loan',
    //         footerBills: 'Bill Payments',
    //         footerCreditScore: 'Free Credit Score',
    //         footerPartner: 'Become Partner',
    //         footerContact: 'Contact Us',
    //         footerPhone: '9909002220',
    //         footerEmail: 'krishnafinconcept09@gmail.com',
    //         footerAddress: 'Available in 4,000+ cities across India',
    //         footerTiming: 'Mon-Sat: 9AM-9PM | Sun: 10AM-6PM',
    //         copyrightText: '© 2025 Krishna Finconcept Services Financial Services. All rights reserved.',
    //         privacyLink: 'Privacy Policy',
    //         termsLink: 'Terms & Conditions',
    //         disclaimerLink: 'Disclaimer'
    //     },
    //     // FULL hindi translation object (replace the entire hindi: { ... } in your translations)

    //     // Inside translations = { ... }
    //     hindi: {
    //         logo: "फिनलिंक",
    //         navHome: "होम",
    //         navServices: "सेवाएं",
    //         navAbout: 'हमारे बारे में',
    //         navDsa: "भागीदार बनें",

    //         navFaq: "सामान्य प्रश्न",
    //         navContact: "संपर्क करें",
    //         navCareer: 'करियर हमारे साथ',
    //         navHelp: 'हेल्प डेस्क',
    //         partnerButton: "लॉगिन",
    //         applyButton: "डीएसए बनें",

    //         heroTitleLine1: "भारत का अग्रणी ऋण",
    //         heroTitleLine2: "और वित्तीय सेवा प्लेटफॉर्म",
    //         heroDescription: "100+ बैंकिंग भागीदारों से होम लोन, पर्सनल लोन, बिजनेस लोन, क्रेडिट कार्ड, बीमा और बहुत कुछ के लिए जुड़ें। तत्काल पात्रता जांच और डिजिटल दस्तावेज जमा के साथ सर्वोत्तम दरें प्राप्त करें।",
    //         exploreButton: "पात्रता जांचें",
    //         cibilButton: "सीआईबीआईएल स्कोर जांचें",

    //         statExpText: "वर्षों का अनुभव",
    //         statPartnersText: "बैंकिंग भागीदार",
    //         statCitiesText: "फ्रीलांसर्स",
    //         statLoansText: "संतुष्ट ग्राहक",

    //         productsTitle: "हम वित्तीय उत्पादों की विस्तृत श्रृंखला को सुलभ बनाते हैं",
    //         productsSubtitle: "जो आपके ग्राहक की जरूरतों के अनुरूप है! हमारे व्यापक वित्तीय समाधानों में से चुनें",

    //         product1Title: "होम लोन",
    //         product1Desc: "आपका सपनों का घर इंतजार कर रहा है - लचीले विकल्पों के साथ हमारे होम लोन उत्पादों की श्रृंखला का अन्वेषण करें।",
    //         product1Feature1: "8.5% से शुरू होने वाली सबसे कम ब्याज दरें",
    //         product1Feature2: "संपत्ति मूल्य का 90% तक",
    //         product1Feature3: "30 वर्ष तक की लंबी अवधि",
    //         product1Button: "पात्रता जांचें",

    //         product2Title: "पर्सनल लोन",
    //         product2Desc: "सभी जरूरतों के लिए हमारे बहुमुखी पर्सनल लोन विकल्पों के साथ अपने सपनों को हासिल करें।",
    //         product2Feature1: "₹40 लाख तक की राशि",
    //         product2Feature2: "24 घंटे में तत्काल अनुमोदन",
    //         product2Feature3: "कोई संपार्श्विक आवश्यक नहीं",
    //         product2Button: "अभी आवेदन करें",

    //         product3Title: "प्रॉपर्टी के खिलाफ लोन",
    //         product3Desc: "आकर्षक दरों पर तैयार किए गए लोन समाधानों के साथ अपनी संपत्ति का मूल्य अनलॉक करें।",
    //         product3Feature1: "उच्च मूल्य के ऋण उपलब्ध",
    //         product3Feature2: "सबसे कम ब्याज दरें",
    //         product3Feature3: "लचीले पुनर्भुगतान विकल्प",
    //         product3Button: "ऑफ़र प्राप्त करें",

    //         product4Title: "बिजनेस लोन",
    //         product4Desc: "हमारे लचीले वित्तपोषण विकल्पों और त्वरित वितरण के साथ अपने व्यवसाय की वृद्धि को तेज करें।",
    //         product4Feature1: "₹2 करोड़ तक",
    //         product4Feature2: "न्यूनतम दस्तावेजीकरण",
    //         product4Feature3: "संपार्श्विक-मुक्त विकल्प",
    //         product4Button: "व्यवसाय को बढ़ावा दें",

    //         product5Title: "कार लोन",
    //         product5Desc: "नई और पुरानी गाड़ियों के लिए हमारे त्वरित और लचीले कार लोन के साथ अपनी सपनों की कार चलाएं।",
    //         product5Feature1: "100% ऑन-रोड फंडिंग",
    //         product5Feature2: "प्रतिस्पर्धी ब्याज दरें",
    //         product5Feature3: "तेज प्रसंस्करण",
    //         product5Button: "ऑफ़र जांचें",

    //         product6Title: "एजुकेशन लोन",
    //         product6Desc: "घरेलू और अंतरराष्ट्रीय अध्ययन के लिए हमारे विशेष शिक्षा ऋण के साथ अपने बच्चे के भविष्य में निवेश करें।",
    //         product6Feature1: "ट्यूशन + रहने के खर्च को कवर करता है",
    //         product6Feature2: "मोरेटोरियम अवधि उपलब्ध",
    //         product6Feature3: "धारा 80ई के तहत कर लाभ",
    //         product6Button: "ऋण के लिए आवेदन करें",

    //         insuranceTitle: "बीमा उत्पादों की विस्तृत श्रृंखला",
    //         insuranceSubtitle: "हमारे व्यापक बीमा समाधानों के साथ सबसे महत्वपूर्ण को सुरक्षित रखें",
    //         insurance1Title: "जीवन बीमा",
    //         insurance1Desc: "विश्वसनीय जीवन बीमा योजनाओं के साथ अपने प्रियजनों के भविष्य को सुरक्षित करें।",
    //         insurance1Price: "₹450/माह* से शुरू",
    //         insurance1Button: "कोट प्राप्त करें",

    //         insurance2Title: "स्वास्थ्य बीमा",
    //         insurance2Desc: "सर्वोत्तम कवरेज के साथ सुनिश्चित करना कि आपका स्वास्थ्य अच्छे हाथों में है।",
    //         insurance2Price: "₹450/माह* से शुरू",
    //         insurance2Button: "योजनाओं की तुलना करें",

    //         insurance3Title: "सामान्य बीमा",
    //         insurance3Desc: "बीमा को आसान बनाया गया - वाहनों, यात्रा और बहुत कुछ के लिए आपकी सुरक्षा, हमारी विशेषज्ञता।",
    //         insurance3Price: "₹450/माह* से शुरू",
    //         insurance3Button: "अब अन्वेषण करें",

    //         processTitle: "आसान। सुविधाजनक। तेज़।",
    //         processSubtitle: "90% सफलता दर के साथ आपके ऋण के लिए सरल और त्वरित चरण",
    //         step1Title: "पात्रता जांचें",
    //         step1Desc: "हमें अपनी आवश्यकता बताएं। हमारी एआई 90+ मानदंडों के आधार पर सर्वोत्तम बैंकों से मेल खाती है।",
    //         step2Title: "ऑफ़र की तुलना करें",
    //         step2Desc: "100+ ऋणदाताओं से व्यक्तिगत ऋण विकल्पों को साइड बाय साइड देखें।",
    //         step3Title: "डिजिटल रूप से आवेदन करें",
    //         step3Desc: "आवेदन पूरा करें और दस्तावेज सीधे चयनित बैंकों को जमा करें।",
    //         step4Title: "भुगतान प्राप्त करें",
    //         step4Desc: "सप्ताहों के भीतर नहीं, बल्कि घंटों के भीतर त्वरित अनुमोदन और भुगतान प्राप्त करें।",

    //         dsaTitle: "डीएसए पार्टनर बनें",
    //         dsaSubtitle: "भारत के सबसे तेजी से बढ़ते ऋण वितरण नेटवर्क में शामिल हों और आकर्षक कमीशन कमाना शुरू करें",
    //         dsaDescription: "लोन एजेंट, पूर्व बैंकर, वित्तीय विश्लेषक, बीमा एजेंट, म्यूचुअल फंड एजेंट, चार्टर्ड एकाउंटेंट, बिल्डर या किसी अन्य क्षेत्र के पेशेवर हमारे साथ भागीदार बन सकते हैं।",
    //         benefit1Title: "आकर्षक कमीशन",
    //         benefit1Desc: "प्रत्येक सफल ऋण भुगतान पर प्रतिस्पर्धी कमीशन कमाएं।",
    //         benefit2Title: "व्यापक प्रशिक्षण",
    //         benefit2Desc: "उत्पादों, प्रक्रियाओं और बिक्री तकनीकों पर विस्तृत प्रशिक्षण प्राप्त करें।",
    //         benefit3Title: "समर्पित समर्थन",
    //         benefit3Desc: "पूरी प्रक्रिया में आपकी और आपके ग्राहकों की सहायता के लिए 24/7 समर्थन टीम।",
    //         dsaButton: "पार्टनर के रूप में पंजीकरण करें",

    //         teamTitle: 'टीम से मिलें',  // Hindi for 'Meet the team'
    //         teamMembers: [
    //             {
    //                 name: 'श्री राकेश पांचाल',
    //                 position: 'संस्थापक',
    //                 photo: '/avatars/ceo.png'
    //             },
    //             {
    //                 name: 'Lauren Pybus',
    //                 position: 'वीपी ग्रोथ एंड डेवलपमेंट',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Raelen Thomas',
    //                 position: 'वीपी फाइनेंस ऑपरेशंस',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Mitchell Fawcett',
    //                 position: 'वीपी स्ट्रैटेजी',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Jieu Segal',
    //                 position: 'वीपी सेल्स एंड मार्केटिंग',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Darren Maher',
    //                 position: 'क्रिएटिव डायरेक्टर',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Ben Van Exan',
    //                 position: 'सीनियर अकाउंट एग्जीक्यूटिव',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'John Blown',
    //                 position: 'फाउंडिंग पार्टनर',
    //                 photo: '/avatars/amit.png'
    //             },
    //         ],

    //         faqTitle: "अक्सर पूछे जाने वाले प्रश्न",
    //         faqSubtitle: "हमारी सेवाओं और प्रक्रियाओं के बारे में सामान्य प्रश्नों के उत्तर खोजें",
    //         faq1Question: "कृष्णा फिनकॉन्सेप्ट सर्विसेज क्या है और यह कैसे काम करता है?",
    //         faq1Answer: "कृष्णा फिनकॉन्सेप्ट सर्विसेज एक व्यापक वित्तीय सेवा प्लेटफॉर्म है जो ग्राहकों को लोन, क्रेडिट कार्ड और बीमा के लिए 100+ बैंकिंग भागीदारों से जोड़ता है। हम आपको सर्वोत्तम ऑफ़र से मिलाने, पात्रता जांच में मदद करने और डिजिटल दस्तावेज़ जमा करने की सुविधा के लिए एआई का उपयोग करते हैं।",
    //         faq2Question: "क्या मेरी व्यक्तिगत और वित्तीय जानकारी सुरक्षित है?",
    //         faq2Answer: "हां, हम सख्त सुरक्षा प्रोटोकॉल का पालन करते हैं और सभी डेटा संरक्षण विनियमों का अनुपालन करते हैं। हम आपके बैंक लॉगिन क्रेडेंशियल्स कभी स्टोर नहीं करते हैं और केवल आपके आवेदन के प्रसंस्करण के लिए आपकी स्पष्ट सहमति के साथ ऋणदाताओं के साथ जानकारी साझा करते हैं।",
    //         faq3Question: "मैं डीएसए पार्टनर कैसे बन सकता हूं?",
    //         faq3Answer: "पैन कार्ड और आधार कार्ड वाला कोई भी 25+ आयु वर्ग का व्यक्ति भागीदार बन सकता है। वित्त, रियल एस्टेट, बीमा या किसी भी क्षेत्र के पेशेवर शामिल हो सकते हैं। हम पूर्ण प्रशिक्षण, विपणन सहायता और समय पर कमीशन भुगतान प्रदान करते हैं।",
    //         faq4Question: "क्या आप सभी भारतीय बैंकों का समर्थन करते हैं?",
    //         faq4Answer: "हम एचडीएफसी, आईसीआईसीआई, एसबीआई, एक्सिस, कोटक, बजाज फिनसर्व और कई अन्य सहित 100+ प्रमुख बैंकों और एनबीएफसी के साथ सहयोग करते हैं। हालांकि हम हर एक बैंक को कवर नहीं करते हैं, लेकिन हम भारत की सभी प्रमुख वित्तीय संस्थाओं के साथ काम करते हैं।",





    //         testimonialTitle: 'हमारे ग्राहक क्या कहते हैं',
    //         testimonialSubtitle: 'कृष्णा फिनकॉन्सेप्ट सर्विसेज के साथ अपने अनुभव के बारे में हमारे संतुष्ट ग्राहकों की सुनें',
    //         testimonials: [
    //             { name: 'अमित शर्मा', photo: '/avatars/amit.png', rating: 5, text: 'कृष्णा फिनकॉन्सेप्ट सर्विसेज ने मेरे होम लोन को इतना आसान बना दिया! उत्कृष्ट सेवा और तेज़ स्वीकृति।' },
    //             { name: 'प्रिया पटेल', photo: '/avatars/priya.png', rating: 5, text: 'बहुत सारे विकल्पों वाला शानदार प्लेटफॉर्म। मुझे पर्सनल लोन के लिए सबसे अच्छी ब्याज दर मिली।' },
    //             { name: 'राहुल वर्मा', photo: '/avatars/rahul.png', rating: 4, text: 'DSA पार्टनर के रूप में, कृष्णा फिनकॉन्सेप्ट सर्विसेज ने समय पर कमीशन और बेहतरीन सपोर्ट से मेरी कमाई बढ़ाई है।' },
    //             { name: 'स्नेहा गुप्ता', photo: '/avatars/sneha.png', rating: 5, text: 'तेज़ और परेशानी-मुक्त हेल्थ इंश्योरेंस। डायरेक्ट खरीदारी की तुलना में बहुत बचत हुई!' },
    //             { name: 'विक्रम सिंह', photo: '/avatars/vikram.png', rating: 5, text: 'उपयोगकर्ता-अनुकूल EMI कैलकुलेटर और बिजनेस लोन आवेदन की सहज प्रक्रिया।' }
    //         ],

    //         partnersTitle: "हमारे बैंकिंग भागीदार",
    //         partnersSubtitle: "भारत के अग्रणी वित्तीय संस्थानों द्वारा विश्वसनीय",

    //         // Contact Us Section
    //         contactHeading: 'हमसे संपर्क करें',
    //         contactDesc: 'प्रश्न हैं? ऋण, बीमा या भागीदारी अवसरों पर व्यक्तिगत सहायता के लिए हमसे संपर्क करें।',
    //         phoneTitle: 'हमें कॉल करें',
    //         phoneDesc: '9909002220\सोम-शनि: सुबह 9-रात 9 | रवि: सुबह 10-शाम 6',
    //         emailTitle: 'हमें ईमेल करें',
    //         emailDesc: 'krishnafinconcept09@gmail.com',
    //         formHeading: 'हमें संदेश भेजें',
    //         nameLabel: 'आपका नाम',
    //         emailLabel: 'आपका ईमेल',
    //         phoneLabel: 'आपका फोन',
    //         messageLabel: 'आपका संदेश',
    //         termsText: 'मैं गोपनीयता नीति और उपयोग की शर्तों से सहमत हूं',
    //         submitButton: 'जमा करें',

    //         // Banking Partners Section
    //         bankHeading: 'हमारे भागीदार बैंक और NBFC',
    //         bankDesc: 'हम आपको सबसे अच्छे डील्स लाने के लिए 100+ बैंकों और NBFC के साथ भागीदारी करते हैं।',
    //         viewAll: 'सभी देखें',

    //         footerAbout: "कृष्णा फिनकॉन्सेप्ट सर्विसेज",
    //         footerDescription: "भारत का अग्रणी वित्तीय सेवा प्लेटफॉर्म, ग्राहकों को लोन, क्रेडिट कार्ड, बीमा और निवेश उत्पादों के लिए 100+ बैंकिंग भागीदारों से जोड़ता है।",
    //         footerProducts: "ऋण उत्पाद",
    //         footerHome: "होम लोन",
    //         footerPersonal: "पर्सनल लोन",
    //         footerBusiness: "बिजनेस लोन",
    //         footerLap: "प्रॉपर्टी के खिलाफ लोन",
    //         footerCar: "कार लोन",
    //         footerEducation: "शिक्षा ऋण",
    //         footerServices: "अन्य सेवाएं",
    //         footerCredit: "क्रेडिट कार्ड",
    //         footerInsurance: "बीमा",
    //         footerGold: "गोल्ड लोन",
    //         footerBills: "बिल भुगतान",
    //         footerCreditScore: "मुफ्त क्रेडिट स्कोर",
    //         footerPartner: "भागीदार बनें",
    //         footerContact: "हमसे संपर्क करें",
    //         footerPhone: "9909002220",
    //         footerEmail: "krishnafinconcept09@gmail.com",
    //         footerAddress: "भारत के 4,000+ शहरों में उपलब्ध",
    //         footerTiming: "सोम-शनि: सुबह 9-रात 9 | रवि: सुबह 10-शाम 6",
    //         copyrightText: "© 2025 कृष्णा फिनकॉन्सेप्ट सर्विसेज फाइनेंशियल सर्विसेज। सभी अधिकार सुरक्षित।",
    //         privacyLink: "गोपनीयता नीति",
    //         termsLink: "नियम एवं शर्तें",
    //         disclaimerLink: "डिस्क्लेमर"
    //     },
    //     // FULL gujarati translation object (replace the entire gujarati: { ... } in your translations)

    //     gujarati: {
    //         logo: "ફિનલિંક",
    //         navHome: "હોમ",
    //         navServices: "સેવાઓ",
    //         navAbout: 'અમારા વિશે',
    //         navDsa: "ભાગીદાર બનો",

    //         navFaq: "પ્રશ્નો-જવાબો",
    //         navContact: "સંપર્ક કરો",
    //         navCareer: 'કારકિર્દી અમારી સાથે',
    //         navHelp: 'હેલ્પ ડેસ્ક',
    //         partnerButton: "લૉગિન",
    //         applyButton: "DSA બની જાઓ",

    //         heroTitleLine1: "ભારતની અગ્રણી લોન",
    //         heroTitleLine2: "અને નાણાકીય સેવા પ્લેટફોર્મ",
    //         heroDescription: "100+ બેંકિંગ ભાગીદારો સાથે હોમ લોન, પર્સનલ લોન, બિઝનેસ લોન, ક્રેડિટ કાર્ડ, બીમા અને ઘણું બધું માટે જોડાઓ. તાત્કાલિક પાત્રતા તપાસ અને ડિજિટલ દસ્તાવેજ સબમિશન સાથે શ્રેષ્ઠ દરો મેળવો.",
    //         exploreButton: "પાત્રતા તપાસો",
    //         cibilButton: "CIBIL સ્કોર તપાસો",

    //         statExpText: "વર્ષોનો અનુભવ",
    //         statPartnersText: "બેંકિંગ ભાગીદારો",
    //         statCitiesText: "ફ્રીલાન્સર્સ",
    //         statLoansText: "સંતોષિત ગ્રાહક",

    //         productsTitle: "અમે નાણાકીય ઉત્પાદનોની વિશાળ શ્રેણી સુવિધાજનક બનાવીએ છીએ",
    //         productsSubtitle: "જે તમારા ગ્રાહકની જરૂરિયાતોને અનુરૂપ છે! અમારી વ્યાપક નાણાકીય ઉકેલોમાંથી પસંદ કરો",

    //         product1Title: "હોમ લોન",
    //         product1Desc: "તમારું સ્વપ્નનું ઘર રાહ જોઈ રહ્યું છે - લવચીક વિકલ્પો સાથે અમારી હોમ લોન ઉત્પાદનોની શ્રેણીનું અન્વેષણ કરો.",
    //         product1Feature1: "8.5% થી શરૂ થતા સૌથી નીચા વ્યાજ દરો",
    //         product1Feature2: "મિલ્કત મૂલ્યનો 90% સુધી",
    //         product1Feature3: "30 વર્ષ સુધીની લાંબી મુદત",
    //         product1Button: "પાત્રતા તપાસો",

    //         product2Title: "પર્સનલ લોન",
    //         product2Desc: "બધી જરૂરિયાતો માટે અમારા બહુમુખી પર્સનલ લોન વિકલ્પો સાથે તમારા સપનાને હાંસલ કરો.",
    //         product2Feature1: "₹40 લાખ સુધીની રકમ",
    //         product2Feature2: "24 કલાકમાં તાત્કાલિક મંજૂરી",
    //         product2Feature3: "કોઈ જામીનગીરી જરૂરી નથી",
    //         product2Button: "હમણાં અરજી કરો",

    //         product3Title: "મિલકત સામે લોન",
    //         product3Desc: "આકર્ષક દરે તૈયાર થયેલા લોન ઉકેલો સાથે તમારી મિલકતની કિંમત અનલૉક કરો.",
    //         product3Feature1: "ઉચ્ચ મૂલ્યના લોન ઉપલબ્ધ",
    //         product3Feature2: "સૌથી નીચા વ્યાજ દરો",
    //         product3Feature3: "લવચીક માફક પરત ચૂકવણી વિકલ્પો",
    //         product3Button: "ઑફર મેળવો",

    //         product4Title: "બિઝનેસ લોન",
    //         product4Desc: "અમારા લવચીક નાણાંકીય વિકલ્પો અને ઝડપી ચૂકવણી સાથે તમારા વ્યવસાયની વૃદ્ધિને વેગ આપો.",
    //         product4Feature1: "₹2 કરોડ સુધી",
    //         product4Feature2: "ન્યૂનતમ દસ્તાવેજીકરણ",
    //         product4Feature3: "જામીનગીરી મુક્ત વિકલ્પો",
    //         product4Button: "વ્યવસાયને વેગ આપો",

    //         product5Title: "કાર લોન",
    //         product5Desc: "નવી અને જૂની વાહનો માટે અમારા ઝડપી અને લવચીક કાર લોન સાથે તમારી સ્વપ્નની કાર ચલાવો.",
    //         product5Feature1: "100% ઓન-રોડ ફંડિંગ",
    //         product5Feature2: "પ્રતિસ્પર્ધી વ્યાજ દરો",
    //         product5Feature3: "ઝડપી પ્રોસેસિંગ",
    //         product5Button: "ઑફર તપાસો",

    //         product6Title: "એજ્યુકેશન લોન",
    //         product6Desc: "ઘરેલું અને આંતરરાષ્ટ્રીય અભ્યાસ માટે અમારી વિશિષ્ટ શિક્ષણ લોન સાથે તમારા બાળકના ભવિષ્યમાં રોકાણ કરો.",
    //         product6Feature1: "ટ્યૂશન + રહેવાનો ખર્ચ આવરી લે છે",
    //         product6Feature2: "મોરેટોરિયમ અવધિ ઉપલબ્ધ",
    //         product6Feature3: "કલમ 80ઈ હેઠળ કર લાભ",
    //         product6Button: "લોન માટે અરજી કરો",

    //         insuranceTitle: "બીમા ઉત્પાદનોની વિશાળ શ્રેણી",
    //         insuranceSubtitle: "અમારા વ્યાપક બીમા ઉકેલો સાથે જે સૌથી વધુ મહત્વનું છે તેને સુરક્ષિત કરો",
    //         insurance1Title: "જીવન બીમા",
    //         insurance1Desc: "વિશ્વસનીય જીવન બીમા યોજનાઓ સાથે તમારા પ્રિયજનોના ભવિષ્યને સુરક્ષિત કરો.",
    //         insurance1Price: "₹450/મહિના* થી શરૂ",
    //         insurance1Button: "કોટ મેળવો",

    //         insurance2Title: "સ્વાસ્થ્ય બીમા",
    //         insurance2Desc: "શ્રેષ્ઠ કવરેજ સાથે તમારા સ્વાસ્થ્ય સારા હાથમાં છે તેની ખાતરી કરવી.",
    //         insurance2Price: "₹450/મહિના* થી શરૂ",
    //         insurance2Button: "યોજનાઓની તુલના કરો",

    //         insurance3Title: "સામાન્ય બીમા",
    //         insurance3Desc: "બીમા સરળ બનાવ્યું - વાહનો, મુસાફરી અને ઘણું બધું માટે તમારું સુરક્ષા, અમારી નિષ્ણાતતા.",
    //         insurance3Price: "₹450/મહિના* થી શરૂ",
    //         insurance3Button: "હવે અન્વેષણ કરો",

    //         processTitle: "સરળ. સુવિધાજનક. ઝડપી.",
    //         processSubtitle: "90% સફળતા દર સાથે તમારા લોન માટે સરળ અને ઝડપી પગલાં",
    //         step1Title: "પાત્રતા તપાસો",
    //         step1Desc: "અમને તમારી જરૂરિયાત જણાવો. અમારી એઆઈ 90+ માપદંડોના આધારે શ્રેષ્ઠ બેંકો સાથે મેળ ખાય છે.",
    //         step2Title: "ઑફરની તુલના કરો",
    //         step2Desc: "100+ લોનદાતાઓમાંથી વ્યક્તિગત લોન વિકલ્પોને સાઇડ બાય સાઇડ જુઓ.",
    //         step3Title: "ડિજિટલ રીતે અરજી કરો",
    //         step3Desc: "એપ્લિકેશન પૂર્ણ કરો અને દસ્તાવેજો સીધા પસંદ કરેલી બેંકોને સબમિટ કરો.",
    //         step4Title: "ચુકવણી મેળવો",
    //         step4Desc: "અઠવાડિયામાં નહીં પરંતુ કલાકોની અંદર ઝડપી મંજૂરી અને ચુકવણી મેળવો.",

    //         dsaTitle: "ડીએસએ ભાગીદાર બનો",
    //         dsaSubtitle: "ભારતના સૌથી ઝડપી વધતા લોન વિતરણ નેટવર્કમાં જોડાઓ અને આકર્ષક કમિશન કમાવાનું શરૂ કરો",
    //         dsaDescription: "લોન એજન્ટ, ભૂતપૂર્વ બેંકર, નાણાકીય વિશ્લેષકો, બીમા એજન્ટ, મ્યુચ્યુઅલ ફંડ એજન્ટ, ચાર્ટર્ડ એકાઉન્ટન્ટ, બિલ્ડર અથવા અન્ય કોઈપણ ક્ષેત્રના વ્યવસાયિકો કોઈપણ અમારા સાથે ભાગીદાર બની શકે છે.",
    //         benefit1Title: "આકર્ષક કમિશન",
    //         benefit1Desc: "દરેક સફળ લોન ચુકવણી પર સ્પર્ધાત્મક કમિશન કમાઓ.",
    //         benefit2Title: "વ્યાપક તાલીમ",
    //         benefit2Desc: "ઉત્પાદનો, પ્રક્રિયાઓ અને વેચાણ તકનીકો પર વિગતવાર તાલીમ મેળવો.",
    //         benefit3Title: "સમર્પિત આધાર",
    //         benefit3Desc: "સમગ્ર પ્રક્રિયામાં તમારી અને તમારા ગ્રાહકોની સહાય માટે 24/7 સપોર્ટ ટીમ.",
    //         dsaButton: "ભાગીદાર તરીકે નોંધણી કરો",

    //         teamTitle: 'ટીમને મળો',

    //         teamMembers: [
    //             {
    //                 name: 'શ્રી રાકેશ પંચાલ',
    //                 position: 'સ્થાપક',
    //                 photo: '/avatars/ceo.png'
    //             },
    //             {
    //                 name: 'Lauren Pybus',
    //                 position: 'વીપી ગ્રોથ એન્ડ ડેવલપમેન્ટ',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Raelen Thomas',
    //                 position: 'વીપી ફાઇનાન્સ ઓપરેશન્સ',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Mitchell Fawcett',
    //                 position: 'વીપી સ્ટ્રેટેજી',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Jieu Segal',
    //                 position: 'વીપી સેલ્સ એન્ડ માર્કેટિંગ',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Darren Maher',
    //                 position: 'ક્રિએટિવ ડિરેક્ટર',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'Ben Van Exan',
    //                 position: 'સિનિયર એકાઉન્ટ એક્ઝિક્યુટિવ',
    //                 photo: '/avatars/amit.png'
    //             },
    //             {
    //                 name: 'John Blown',
    //                 position: 'ફાઉન્ડિંગ પાર્ટનર',
    //                 photo: '/avatars/amit.png'
    //             },
    //         ],

    //         faqTitle: "વારંવાર પૂછાતા પ્રશ્નો",
    //         faqSubtitle: "અમારી સેવાઓ અને પ્રક્રિયાઓ વિશેના સામાન્ય પ્રશ્નોના જવાબો શોધો",
    //         faq1Question: "કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ શું છે અને તે કેવી રીતે કાર્ય કરે છે?",
    //         faq1Answer: "કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ એક વ્યાપક નાણાકીય સેવા પ્લેટફોર્મ છે જે ગ્રાહકોને લોન, ક્રેડિટ કાર્ડ અને બીમા માટે 100+ બેંકિંગ ભાગીદારો સાથે જોડે છે. અમે તમને શ્રેષ્ઠ ઑફર સાથે મેચ કરવા, પાત્રતા તપાસમાં મદદ કરવા અને ડિજિટલ દસ્તાવેજ સબમિશનની સુવિધા માટે એઆઈનો ઉપયોગ કરીએ છીએ.",
    //         faq2Question: "શું મારી વ્યક્તિગત અને નાણાકીય માહિતી સુરક્ષિત છે?",
    //         faq2Answer: "હા, અમે કડક સુરક્ષા પ્રોટોકોલનું પાલન કરીએ છીએ અને તમામ ડેટા સંરક્ષણ નિયમોનું પાલન કરીએ છીએ. અમે તમારા બેંક લોગિન ક્રેડેન્શિયલ્સ ક્યારેય સંગ્રહિત કરતા નથી અને ફક્ત તમારી એપ્લિકેશન પ્રોસેસિંગ માટે તમારી સ્પષ્ટ સંમતિ સાથે લોનદાતાઓ સાથે માહિતી શેર કરીએ છીએ.",
    //         faq3Question: "હું ડીએસએ ભાગીદાર કેવી રીતે બની શકું?",
    //         faq3Answer: "પૅન કાર્ડ અને આધાર કાર્ડ ધરાવતા 25+ વર્ષની ઉંમરના કોઈપણ વ્યક્તિ ભાગીદાર બની શકે છે. નાણાં, રીઅલ એસ્ટેટ, બીમા અથવા કોઈપણ ક્ષેત્રના વ્યવસાયિકો જોડાઈ શકે છે. અમે સંપૂર્ણ તાલીમ, માર્કેટિંગ સહાય અને સમયસર કમિશન ચુકવણી પ્રદાન કરીએ છીએ.",
    //         faq4Question: "શું તમે બધા ભારતીય બેંકોને સપોર્ટ કરો છો?",
    //         faq4Answer: "અમે એચડીએફસી, આઈસીઆઈસીઆઈ, એસબીઆઈ, એક્સિસ, કોટક, બજાજ ફિનસર્વ અને ઘણા બધા સહિત 100+ પ્રમુખ બેંકો અને એનબીએફસી સાથે સહયોગ કરીએ છીએ. જ્યારે અમે દરેક એક બેંકને કવર કરતા નથી, પરંતુ અમે ભારતની તમામ પ્રમુખ નાણાકીય સંસ્થાઓ સાથે કામ કરીએ છીએ.",

    //         testimonialTitle: 'અમારા ગ્રાહકો શું કહે છે',
    //         testimonialSubtitle: 'કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ સાથેના તેમના અનુભવ વિશે અમારા સંતુષ્ટ ગ્રાહકો પાસેથી સાંભળો',
    //         testimonials: [
    //             { name: 'અમિત શર્મા', photo: '/avatars/amit.png', rating: 5, text: 'કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ એ મારી હોમ લોનને ખૂબ સરળ બનાવી! ઉત્તમ સેવા અને ઝડપી મંજૂરી.' },
    //             { name: 'પ્રિયા પટેલ', photo: '/avatars/priya.png', rating: 5, text: 'ઘણા વિકલ્પો સાથેનું શાનદાર પ્લેટફોર્મ. મને પર્સનલ લોન માટે શ્રેષ્ઠ વ્યાજ દર મળ્યો.' },
    //             { name: 'રાહુલ વર્મા', photo: '/avatars/rahul.png', rating: 4, text: 'DSA પાર્ટનર તરીકે, કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ એ સમયસર કમિશન અને શાનદાર સપોર્ટથી મારી કમાણી વધારી છે.' },
    //             { name: 'સ્નેહા ગુપ્તા', photo: '/avatars/sneha.png', rating: 5, text: 'ઝડપી અને મુશ્કેલી-મુક્ત હેલ્થ ઇન્શ્યોરન્સ. ડાયરેક્ટ ખરીદીની તુલનાએ ઘણી બચત થઈ!' },
    //             { name: 'વિક્રમ સિંહ', photo: '/avatars/vikram.png', rating: 5, text: 'યુઝર-ફ્રેન્ડલી EMI કેલ્ક્યુલેટર અને બિઝનેસ લોન અરજીની સરળ પ્રક્રિયા.' }
    //         ],

    //         partnersTitle: "અમારા બેંકિંગ ભાગીદારો",
    //         partnersSubtitle: "ભારતની અગ્રણી નાણાકીય સંસ્થાઓ દ્વારા વિશ્વસનીય",

    //         // Contact Us Section
    //         contactHeading: 'અમારો સંપર્ક કરો',
    //         contactDesc: 'પ્રશ્નો છે? લોન, વીમા અથવા ભાગીદારી તકો પર વ્યક્તિગત સહાય માટે અમારો સંપર્ક કરો.',
    //         phoneTitle: 'અમને કૉલ કરો',
    //         phoneDesc: '9909002220\nસોમ-શનિ: સવાર 9-રાત 9 | રવિ: સવાર 10-સાંજ 6',
    //         emailTitle: 'અમને ઈમેઇલ કરો',
    //         emailDesc: 'krishnafinconcept09@gmail.com',
    //         formHeading: 'અમને સંદેશ મોકલો',
    //         nameLabel: 'તમારું નામ',
    //         emailLabel: 'તમારું ઈમેઇલ',
    //         phoneLabel: 'તમારો ફોન',
    //         messageLabel: 'તમારો સંદેશ',
    //         termsText: 'હું ગોપનીયતા નીતિ અને વપરાશની શરતો સાથે સંમત છું',
    //         submitButton: 'સબમિટ કરો',

    //         // Banking Partners Section
    //         bankHeading: 'અમારા ભાગીદાર બેંક અને NBFC',
    //         bankDesc: 'અમે તમને શ્રેષ્ઠ ડીલ્સ લાવવા માટે 100+ બેંકો અને NBFC સાથે ભાગીદારી કરીએ છીએ.',
    //         viewAll: 'બધા જુઓ',

    //         footerAbout: "કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ",
    //         footerDescription: "ભારતનું અગ્રણી નાણાકીય સેવા પ્લેટફોર્મ, ગ્રાહકોને લોન, ક્રેડિટ કાર્ડ, બીમા અને રોકાણ ઉત્પાદનો માટે 100+ બેંકિંગ ભાગીદારો સાથે જોડે છે.",
    //         footerProducts: "લોન ઉત્પાદનો",
    //         footerHome: "હોમ લોન",
    //         footerPersonal: "પર્સનલ લોન",
    //         footerBusiness: "બિઝનેસ લોન",
    //         footerLap: "મિલકત સામે લોન",
    //         footerCar: "કાર લોન",
    //         footerEducation: "એજ્યુકેશન લોન",
    //         footerServices: "અન્ય સેવાઓ",
    //         footerCredit: "ક્રેડિટ કાર્ડ",
    //         footerInsurance: "બીમા",
    //         footerGold: "ગોલ્ડ લોન",
    //         footerBills: "બિલ પેમેન્ટ",
    //         footerCreditScore: "મફત ક્રેડિટ સ્કોર",
    //         footerPartner: "ભાગીદાર બનો",
    //         footerContact: "અમારો સંપર્ક કરો",
    //         footerPhone: "9909002220",
    //         footerEmail: "krishnafinconcept09@gmail.com",
    //         footerAddress: "ભારતના 4,000+ શહેરોમાં ઉપલબ્ધ",
    //         footerTiming: "સોમ-શનિ: સવાર 9-રાત 9 | રવિ: સવાર 10-સાંજ 6",
    //         copyrightText: "© 2025 કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ નાણાકીય સેવાઓ. બધા હક્કો આરક્ષિત.",
    //         privacyLink: "ગોપનીયતા નીતિ",
    //         termsLink: "નિયમો અને શરતો",
    //         disclaimerLink: "નિરાકરણ"
    //     }
    // };
    // const t = translations[currentLanguage];

    const handleDsaSubmit = async (e) => {
        e.preventDefault();

        // First submit Step 3 data
        try {
            await submitStep3();
        } catch (error) {
            console.error('Step 3 submission failed:', error);

            // Show error in popup
            setDsaPopupMessage(`❌ Failed to submit documents: ${error.message}`);
            setDsaPopupType('error');
            setShowDsaPopup(true);

            // Auto-hide after 5 seconds
            setTimeout(() => {
                setShowDsaPopup(false);
            }, 5000);
            return;
        }

        // Final validation
        if (!validateCurrentStep()) {
            return;
        }

        // Additional validation for final submission
        if (!dsaForm.fullname || !dsaForm.pan || !dsaForm.email || !dsaForm.mobile) {
            setDsaPopupMessage('❌ Please complete all required personal information');
            setDsaPopupType('error');
            setShowDsaPopup(true);
            return;
        }

        if (!dsaForm.experience || !dsaForm.profession) {
            setDsaPopupMessage('❌ Please complete professional information');
            setDsaPopupType('error');
            setShowDsaPopup(true);
            return;
        }

        if (!selfiePhoto || !aadhaarFront || !aadhaarBack || !panCardPhoto || !cancelCheque) {
            setDsaPopupMessage('❌ Please upload all required documents');
            setDsaPopupType('error');
            setShowDsaPopup(true);
            return;
        }

        // Terms and conditions check
        const termsCheckbox = document.getElementById('agreeTerms');
        if (!termsCheckbox || !termsCheckbox.checked) {
            setDsaPopupMessage('❌ Please agree to the Terms & Conditions to proceed');
            setDsaPopupType('error');
            setShowDsaPopup(true);
            return;
        }

        setIsSubmitting(true);

        try {
            // Show loading in popup
            setDsaPopupMessage('⏳ Processing your application...');
            setDsaPopupType('info');
            setShowDsaPopup(true);

            // Create FormData object for logging/validation
            const formData = new FormData();

            // Personal Information
            formData.append('fullname', dsaForm.fullname);
            formData.append('pan', dsaForm.pan);
            formData.append('dob', dsaForm.dob);
            formData.append('email', dsaForm.email);
            formData.append('mobile', dsaForm.mobile);
            formData.append('gender', dsaForm.gender);
            formData.append('address', dsaForm.address);
            formData.append('pincode', dsaForm.pincode);
            formData.append('city', dsaForm.city);
            formData.append('state', dsaForm.state);
            formData.append('area', dsaForm.area);


            // Professional Information
            formData.append('experience', dsaForm.experience);
            formData.append('profession', dsaForm.profession);

            // Required Documents
            if (selfiePhoto) formData.append('selfie_photo', selfiePhoto);
            if (officePhoto) formData.append('office_photo', officePhoto);
            if (aadhaarFront) formData.append('aadhaar_front', aadhaarFront);
            if (aadhaarBack) formData.append('aadhaar_back', aadhaarBack);
            if (panCardPhoto) formData.append('pan_card_photo', panCardPhoto);
            if (cancelCheque) formData.append('cancel_cheque', cancelCheque);

            // Other Documents - FIXED
            const validOtherDocs = otherDocuments.filter(doc =>
                doc && (doc.text || doc.file) && (doc.text?.trim() || doc.file)
            );
            validOtherDocs.forEach((doc, index) => {
                if (doc.file) {
                    formData.append(`other_documents[${index}][file]`, doc.file);
                    formData.append(`other_documents[${index}][document_type]`, doc.type || 'other');
                    formData.append(`other_documents[${index}][document_name]`, doc.name || `Document ${index + 1}`);
                } else if (doc.text && doc.text.trim()) {
                    formData.append(`other_documents[${index}]`, doc.text);
                }
            });

            // Log form data for debugging
            console.log('DSA Form Data Summary:', {
                personalInfo: {
                    fullname: dsaForm.fullname,
                    email: dsaForm.email,
                    mobile: dsaForm.mobile,
                    pan: dsaForm.pan,
                    dob: dsaForm.dob,
                    gender: dsaForm.gender,
                    address: dsaForm.address.substring(0, 50) + '...',
                    pincode: dsaForm.pincode,
                    city: dsaForm.city,
                    state: dsaForm.state
                },
                professionalInfo: {
                    experience: dsaForm.experience,
                    profession: dsaForm.profession
                },
                documents: {
                    selfie: selfiePhoto ? `${selfiePhoto.name} (${formatFileSize(selfiePhoto.size)})` : 'Missing',
                    aadhaarFront: aadhaarFront ? `${aadhaarFront.name} (${formatFileSize(aadhaarFront.size)})` : 'Missing',
                    aadhaarBack: aadhaarBack ? `${aadhaarBack.name} (${formatFileSize(aadhaarBack.size)})` : 'Missing',
                    panCard: panCardPhoto ? `${panCardPhoto.name} (${formatFileSize(panCardPhoto.size)})` : 'Missing',
                    cancelCheque: cancelCheque ? `${cancelCheque.name} (${formatFileSize(cancelCheque.size)})` : 'Missing',
                    officePhoto: officePhoto ? `${officePhoto.name} (${formatFileSize(officePhoto.size)})` : 'Not uploaded',
                    otherDocuments: validOtherDocs.length
                },
                timestamp: new Date().toISOString()
            });

            // Show loading animation
            const submitBtn = document.querySelector('.submit-dsa-btn');
            if (submitBtn) {
                submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Processing...';
                submitBtn.disabled = true;
            }

            // Simulate processing delay
            await new Promise(resolve => setTimeout(resolve, 1500));

            // Generate reference ID
            const referenceId = 'DSA' + Date.now().toString().slice(-8) + Math.random().toString(36).substr(2, 4).toUpperCase();

            // Show success popup
            setDsaPopupMessage('DSA Form Submitted Successfully!\nThank you for choosing Krishna Finconcept Services!');
            setDsaPopupType('success');
            setShowDsaPopup(true);

            // Store application data in localStorage (for demo purposes)
            const applicationData = {
                reference_id: referenceId,
                fullname: dsaForm.fullname,
                email: dsaForm.email,
                mobile: dsaForm.mobile,
                application_date: new Date().toISOString(),
                status: 'pending',
                steps_completed: 3
            };

            localStorage.setItem('dsaApplicationData', JSON.stringify(applicationData));
            localStorage.setItem('lastDSAReference', referenceId);

            // Reset form and close modal after a delay
            setTimeout(() => {
                resetDsaForm();
                document.body.style.overflow = 'auto';
                setIsDSAFormOpen(false);
                setShowDsaPopup(false);
            }, 3000);

        } catch (error) {
            console.error('Error in DSA form submission:', error);

            // Extract error message - backend errors are already formatted
            let errorMessage = error.message || 'An error occurred. Please try again.';

            // Show error in popup
            setDsaPopupMessage(`❌ ${errorMessage}`);
            setDsaPopupType('error');
            setShowDsaPopup(true);

            // Reset button state
            const submitBtn = document.querySelector('.submit-dsa-btn');
            if (submitBtn) {
                submitBtn.innerHTML = '<i className="fas fa-paper-plane"></i> Submit Application';
                submitBtn.disabled = false;
            }

            // Auto-hide error popup after 5 seconds
            setTimeout(() => {
                setShowDsaPopup(false);
            }, 5000);

        } finally {
            setIsSubmitting(false);
        }
    };

    const submitStep3 = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL || 'https://kfs09.in/api';
            const userId = localStorage.getItem('dsa_user_id');

            if (!userId) {
                throw new Error('User ID not found. Please complete previous steps first.');
            }

            const formData = new FormData();
            formData.append('user_id', userId);
            formData.append('terms_accepted', 'true');

            // Append required documents
            if (aadhaarFront) formData.append('aadhar_card_front', aadhaarFront);
            if (aadhaarBack) formData.append('aadhar_card_back', aadhaarBack);
            if (panCardPhoto) formData.append('pan_card', panCardPhoto);
            if (cancelCheque) formData.append('cancel_cheque', cancelCheque);

            // Append other documents - FIXED
            otherDocuments.forEach((doc, index) => {
                if (doc && doc.file) {
                    formData.append(`other_documents[${index}][file]`, doc.file);
                    formData.append(`other_documents[${index}][document_type]`, doc.type || 'other');
                    formData.append(`other_documents[${index}][document_name]`, doc.name || `Document ${index + 1}`);
                }
            });

            const response = await fetch(`${apiUrl}/v1/partner/step3`, {
                method: 'POST',
                body: formData
            });

            const result = await response.json();

            if (response.ok) {
                console.log('Step 3 submitted successfully:', result);
                return result;
            } else {
                // Extract detailed error messages from backend
                let errorMessage = 'Step 3 submission failed';

                if (result.errors) {
                    // Use the helper function to format errors
                    errorMessage = formatBackendErrors(result.errors);
                } else if (result.message) {
                    errorMessage = result.message;
                }

                throw new Error(errorMessage);
            }
        } catch (error) {
            console.error('Error submitting Step 3:', error);
            throw error; // Re-throw to be caught by handleDsaSubmit
        }
    };

    const validateCurrentStep = () => {
        switch (dsaStep) {
            case 1: // Personal Information
                // Remove password from validation
                if (!dsaForm.fullname || !dsaForm.pan || !dsaForm.dob ||
                    !dsaForm.email || !dsaForm.mobile || !dsaForm.gender ||
                    !dsaForm.aadhaar_number || !dsaForm.address || !dsaForm.pincode) {
                    alert('Please fill all required fields in Personal Information');
                    return false;
                }

                const panRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
                if (!panRegex.test(dsaForm.pan)) {
                    alert('Please enter a valid PAN number');
                    return false;
                }

                if (!/^\d{12}$/.test(dsaForm.aadhaar_number)) {
                    alert('Please enter a valid 12-digit Aadhaar number');
                    return false;
                }

                return true;

            case 2: // Professional Information
                if (!dsaForm.experience || !dsaForm.profession) {
                    alert('Please fill all required fields in Professional Information');
                    return false;
                }
                return true;

            case 3: // Documents
                if (!aadhaarFront || !aadhaarBack || !panCardPhoto || !cancelCheque) {
                    alert('Please upload all required documents');
                    return false;
                }
                return true;

            default:
                return true;
        }
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0 || !bytes) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    };

    const resetDsaForm = () => {

        // Clear stored user ID
        localStorage.removeItem('dsa_user_id');

        // Reset form state
        setDsaForm({
            fullname: '',
            pan: '',
            dob: '',
            email: '',
            mobile: '',
            gender: '',
            address: '',
            pincode: '',
            city: '',
            state: '',
            area: '',
            experience: '',
            profession: '',
        });

        // Reset other state variables
        setGender('');
        setOtherDocuments(['']); // Reset to one empty field
        setAadhaarFront(null);
        setAadhaarBack(null);
        setPanCardPhoto(null);
        setCancelCheque(null);
        setOfficePhoto(null);
        setSelfiePhoto(null);
        setSelfiePreviewUrl('');
        setOfficePreviewUrl('');

        // Reset to first step
        setDsaStep(1);

        // Clear all file inputs in the form
        const fileInputs = document.querySelectorAll('.dsa-form input[type="file"]');
        fileInputs.forEach(input => {
            input.value = '';
        });

        // Clear all image previews
        const imagePreviews = document.querySelectorAll('.dsa-form .image-preview');
        imagePreviews.forEach(preview => {
            preview.innerHTML = '';
        });

        // Clear other document previews
        const otherDocPreviews = document.querySelectorAll('.other-document-preview');
        otherDocPreviews.forEach(preview => {
            preview.innerHTML = '';
        });

        // Reset terms checkbox
        const termsCheckbox = document.getElementById('agreeTerms');
        if (termsCheckbox) {
            termsCheckbox.checked = false;
        }

        // Reset progress bar active state
        const progressSteps = document.querySelectorAll('.progress-step');
        progressSteps.forEach((step, index) => {
            if (index === 0) {
                step.classList.add('active');
            } else {
                step.classList.remove('active');
            }
        });

        // Reset validation states
        setIsLoadingLocation(false);

        // Reset submit button if exists
        const submitBtn = document.querySelector('.submit-dsa-btn');
        if (submitBtn) {
            submitBtn.innerHTML = '<i class="fas fa-paper-plane"></i> Submit Application';
            submitBtn.disabled = false;
        }

        // Reset next/previous buttons
        const nextBtn = document.querySelector('.next-btn');
        const prevBtn = document.querySelector('.prev-btn');
        if (nextBtn) nextBtn.disabled = false;
        if (prevBtn) prevBtn.disabled = false;

        console.log('✅ DSA form has been reset successfully');
    };

    const formatBackendErrors = (errors) => {
        if (!errors || typeof errors !== 'object') {
            return '❌ An error occurred. Please try again.';
        }

        const errorMessages = [];

        // Handle Laravel validation errors
        Object.entries(errors).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
                const fieldLabel = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                // Add red X before each error
                messages.forEach(message => {
                    errorMessages.push(`❌ ${fieldLabel}: ${message}`);
                });
            }
        });

        return errorMessages.join('\n');
    };


    useEffect(() => {
        const bankingPage = window.location.pathname === '/banking-partners';
        const handleScroll = () => {
            const header = document.getElementById("header-scrolled");

            if (!header) return;
            if (bankingPage) {
                header.classList.add("scrolled");
                header.classList.remove("scrolled-off");
                return;
            }
            if (window.scrollY > 500) {
                header.classList.add("scrolled");
                header.classList.remove("scrolled-off");
            } else {
                header.classList.remove("scrolled");
                header.classList.add("scrolled-off");
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>

            <header>
                <nav className="navbar header-main scrolled-off" id="header-scrolled" >
                    <a href="/">
                        <img
                            src="/images/kfs-logo.png"
                            alt="Finconcept Logo"
                            className="header-logo"
                        />
                    </a>
                    {/* <div className="logo">
                    </div> */}
                    <ul className="nav-links">
                        {/* Home */}
                        <li><a href="/">Home</a></li>

                        {/* About Us */}
                        <li><a onClick={() => navigate('/about')}>About</a></li>

                        {/* Services with Dropdown */}
                        <li className="dropdown services-dropdown">
                            <a href="#services" className="dropbtn">
                                Services <span className="dropdown-arrow">▼</span>
                            </a>
                            <div className="dropdown-content services-dropdown-content">
                                {/* All Loan with Sub-dropdown */}
                                <div className="dropdown-submenu">
                                    <a href="javascript:void(0)" className="submenu-trigger">
                                        All Loan <span className="submenu-arrow">▶</span>
                                    </a>
                                    <div className="submenu-content">
                                        <a href="/home-loan" target="_blank" rel="noopener noreferrer">Home Loan</a>
                                        <a href="/personal-loan" target="_blank" rel="noopener noreferrer">Personal Loan</a>
                                        <a href="/loan-against-property" target="_blank" rel="noopener noreferrer">Loan Against Property</a>
                                        <a href="/business-loan" target="_blank" rel="noopener noreferrer">Business Loan</a>
                                        <a href="/car-loan" target="_blank" rel="noopener noreferrer">Car Loan</a>
                                        <a href="/education-loan" target="_blank" rel="noopener noreferrer">Education Loan</a>
                                        <a href="/insta-loan" rel="noopener noreferrer" onClick={(e) => { e.preventDefault(); navigate('/insta-loan'); }}>Insta Loan</a>
                                        {/*<a href="/gold-loan" target="_blank" rel="noopener noreferrer">Gold Loan</a>*/}
                                    </div>
                                </div>

                                {/* Other Services */}
                                <a onClick={() => navigate('/coming')}>Insurance</a>
                                <a onClick={() => navigate('/coming')}>Website</a>
                                <a onClick={() => navigate('/coming')}>CRM</a>
                            </div>
                        </li>

                        {/* Help Desk */}
                        <li><a onClick={() => navigate('/help')}>help</a></li>

                        {/* Contact Us */}
                        <li><a href="#contact" onClick={(e) => {
                            e.preventDefault();
                            document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                        }}>Contact</a></li>
                    </ul>
                    <div className="nav-buttons">
                        <button className="partner-btn" onClick={() => navigate('/coming')}>Login</button>
                        <button className="apply-btn" onClick={() => {
                            document.body.style.overflow = 'hidden';
                            setIsDSAFormOpen(true)
                        }}>Become DSA</button>
                        {/* Language Dropdown */}
                        <div id="google_translate_element" style={{ display: "none" }} />
                        <div className="language-selector">
                            <button
                                className="language-button"
                                onClick={() => setIsLanguageMenuOpen(!isLanguageMenuOpen)}
                                style={{ padding: "0 8px" }}
                            >
                                <span className="globe-icon">🌐</span>
                                <span className="dropdown-arrow" style={{ marginLeft: "4px" }}>
                                    ▼
                                </span>
                            </button>

                            {isLanguageMenuOpen && (
                                <ul className="language-menu">
                                    <li onClick={() => changeLanguage("en")}>
                                        <span className="country-code">US</span> English
                                    </li>

                                    <li onClick={() => changeLanguage("hi")}>
                                        <span className="country-code">IN</span> हिन्दी
                                    </li>

                                    <li onClick={() => changeLanguage("gu")}>
                                        <span className="country-code">IN</span> ગુજરાતી
                                    </li>
                                </ul>
                            )}
                        </div>
                        {/* <div className="language-selector">
                            <button
                                className="language-button"
                                onClick={() => setIsLanguageMenuOpen(!isLanguageMenuOpen)}
                                style={{ padding: '0 8px' }}
                            >
                                <span className="globe-icon">🌐</span>
                                {currentLanguage === 'english' ? '' : currentLanguage === 'hindi' ? '' : ''}
                                <span className="dropdown-arrow" style={{ marginLeft: '4px' }}>▼</span>
                            </button>
                            {isLanguageMenuOpen && (
                                <ul className="language-menu">
                                    <li
                                    // onClick={() => { setCurrentLanguage('english'); setIsLanguageMenuOpen(false); }}
                                    >
                                        <span className="country-code">US</span> English
                                    </li>
                                    <li
                                    // onClick={() => { setCurrentLanguage('hindi'); setIsLanguageMenuOpen(false); }}
                                    >
                                        <span className="country-code">IN</span> हिन्दी
                                    </li>
                                    <li
                                    //  onClick={() => { setCurrentLanguage('gujarati'); setIsLanguageMenuOpen(false); }}
                                    >
                                        <span className="country-code">IN</span> ગુજરાતી
                                    </li>
                                </ul>
                            )}
                        </div> */}
                    </div>
                </nav>
            </header>

            <Breadcrumb />


            {/* Mobile Sidebar Menu */}
            <div className={`mobile-sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
                <div className="mobile-sidebar-header">
                    <div className="logo">
                        <img
                            src="/images/kfs-logo.png"
                            alt="Finconcept Logo"
                            className="header-logo"
                        />
                    </div>
                    <button
                        className="mobile-close-btn"
                        onClick={() => setIsMobileMenuOpen(false)}
                    >
                        ×
                    </button>
                </div>

                {/* Mobile Sidebar Menu */}
                <div className="mobile-nav-links">
                    {/* Home */}
                    <a href="/" onClick={() => setIsMobileMenuOpen(false)}>Home</a>

                    {/* About Us */}
                    <a href="/about" onClick={() => setIsMobileMenuOpen(false)}>About</a>

                    {/* Services with sub-menu for mobile */}
                    <div className="mobile-dropdown">
                        <a href="#services" onClick={() => setIsMobileMenuOpen(false)}>Services</a>
                        <div className="mobile-dropdown-content">
                            {/* All Loan with submenu for mobile */}
                            <div className="mobile-submenu">
                                <a href="#all-loans" className="mobile-submenu-trigger">
                                    All Loan <span className="mobile-submenu-arrow">▼</span>
                                </a>
                                <div className="mobile-submenu-content">
                                    <a href="/home-loan" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Home Loan</a>
                                    <a href="/personal-loan" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Personal Loan</a>
                                    <a href="/loan-against-property" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Loan Against Property</a>
                                    <a href="/business-loan" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Business Loan</a>
                                    <a href="/car-loan" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Car Loan</a>
                                    <a href="/education-loan" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Education Loan</a>
                                    <a href="/gold-loan" target="_blank" rel="noopener noreferrer" onClick={() => setIsMobileMenuOpen(false)}>Gold Loan</a>
                                    <a href="/insta-loan" rel="noopener noreferrer" onClick={() => { setIsMobileMenuOpen(false); navigate('/insta-loan'); }}>Insta Loan</a>
                                </div>
                            </div>

                            <a onClick={() => {
                                setIsMobileMenuOpen(false);
                                navigate('/coming');
                            }}>Insurance</a>
                            <a onClick={() => {
                                setIsMobileMenuOpen(false);
                                navigate('/coming');
                            }}>Website</a>
                            <a onClick={() => {
                                setIsMobileMenuOpen(false);
                                navigate('/coming');
                            }}>CRM</a>
                        </div>
                    </div>

                    {/* Help Desk */}
                    <a href="/help" onClick={() => setIsMobileMenuOpen(false)}>Help</a>

                    {/* Contact Us */}
                    <a href="#contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</a>
                </div>

                <div className="mobile-nav-buttons">
                    <button className="mobile-partner-btn" onClick={() => {
                        setIsMobileMenuOpen(false);
                        navigate('/coming');
                    }}>Login</button>
                    <button className="mobile-apply-btn">Become DSA</button>
                </div>
            </div>


            <div className="mobile-menu-toggle-container">
                <img
                    src="/images/kfs-logo.png"
                    alt="Finconcept Logo"
                    className="header-logo"
                />
                <div className='language-toggle-button'>
                    {/* Language Dropdown */}
                    <div className="language-selector">
                        <button
                            className="language-button"
                            onClick={() => setIsLanguageMenuOpen(!isLanguageMenuOpen)}
                            style={{ padding: '0 8px' }}
                        >
                            <span className="globe-icon">🌐</span>
                            {currentLanguage === 'english' ? '' : currentLanguage === 'hindi' ? '' : ''}
                            <span className="dropdown-arrow" style={{ marginLeft: '4px' }}>▼</span>
                        </button>
                        {isLanguageMenuOpen && (
                            <ul className="language-menu">
                                <li
                                // onClick={() => { setCurrentLanguage('english'); setIsLanguageMenuOpen(false); }}
                                >
                                    <span className="country-code">US</span> English
                                </li>
                                <li
                                // onClick={() => { setCurrentLanguage('hindi'); setIsLanguageMenuOpen(false); }}
                                >
                                    <span className="country-code">IN</span> हिन्दी
                                </li>
                                <li
                                //  onClick={() => { setCurrentLanguage('gujarati'); setIsLanguageMenuOpen(false); }}
                                >
                                    <span className="country-code">IN</span> ગુજરાતી
                                </li>
                            </ul>
                        )}
                    </div>
                    <button
                        className="mobile-menu-toggle"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            {isMobileMenuOpen && (
                <div
                    className="mobile-overlay"
                    onClick={() => setIsMobileMenuOpen(false)}
                />
            )}

            {isDSAFormOpen && (
                <div className="dsa-modal-overlay" onClick={() => {
                    setIsDSAFormOpen(false)
                    document.body.style.overflow = 'auto';
                }}>
                    <div className="dsa-modal" onClick={(e) => e.stopPropagation()}>
                        {/* Modal Header with Professional Design */}
                        <div className="dsa-modal-header">
                            <div className="modal-header-content">
                                <div className="modal-title-icon">
                                    <i className="fas fa-handshake"></i>
                                </div>
                                <div>
                                    <h2>Become a DSA Partner</h2>
                                    <p className="modal-subtitle">Join India's Fastest Growing Loan Distribution Network</p>
                                </div>
                            </div>
                            <button className="close-modal-btn" onClick={() => {
                                document.body.style.overflow = 'auto';
                                setIsDSAFormOpen(false)
                            }}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>

                        {/* Progress Steps - Updated for 3 steps */}
                        <div className="modal-progress-steps">
                            <div className={`progress-step ${dsaStep >= 1 ? 'active' : ''}`}>
                                <span className="step-number">1</span>
                                <span className="step-text">Personal Details</span>
                            </div>
                            <div className={`progress-step ${dsaStep >= 2 ? 'active' : ''}`}>
                                <span className="step-number">2</span>
                                <span className="step-text">Professional Info</span>
                            </div>
                            <div className={`progress-step ${dsaStep >= 3 ? 'active' : ''}`}>
                                <span className="step-number">3</span>
                                <span className="step-text">Documents</span>
                            </div>
                        </div>

                        <div className="dsa-modal-content">
                            <form className="dsa-form" onSubmit={handleDsaSubmit}>

                                {/* DSA Success Message Display */}
                                {dsaSubmitMessage && (
                                    <div className={`dsa-submit-message ${dsaSubmitStatus}`}>
                                        {dsaSubmitMessage}
                                        <button
                                            className="close-dsa-message-btn"
                                            onClick={() => {
                                                setDsaSubmitMessage('');
                                                setDsaSubmitStatus('');
                                            }}
                                        >
                                            ×
                                        </button>
                                    </div>
                                )}


                                {/* Step 1: Personal Information */}
                                {dsaStep === 1 && (
                                    <div className="form-step">
                                        <div className="form-section-header">
                                            <h3><i className="fas fa-user-circle"></i> Personal Information</h3>
                                            <p>Fill in your basic details to begin the partnership process</p>
                                        </div>

                                        {/* Row 1: Full Name | PAN | Date of Birth */}
                                        <div className="form-columns-3">
                                            <div className="form-group">
                                                <label>Full Name (As per PAN Card) *</label>
                                                <div className="input-with-icon">
                                                    <i className="fas fa-user"></i>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter your full name"
                                                        required
                                                        value={dsaForm.fullname}
                                                        onChange={(e) => handleDsaInputChange('fullname', e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>PAN Number *</label>
                                                <div className="input-with-icon">
                                                    <i className="fas fa-id-card"></i>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter PAN number"
                                                        required
                                                        value={dsaForm.pan}
                                                        onChange={(e) => handleDsaInputChange('pan', e.target.value.toUpperCase())}
                                                        maxLength="10"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>Date of Birth *</label>
                                                <div className="input-with-icon">
                                                    <i className="fas fa-calendar-alt"></i>
                                                    <input
                                                        type="date"
                                                        required
                                                        value={dsaForm.dob}
                                                        onChange={(e) => handleDsaInputChange('dob', e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Row 2: Email | Mobile | Gender */}
                                        <div className="form-columns-3">
                                            <div className="form-group">
                                                <label>Email Address *</label>
                                                <div className="input-with-icon">
                                                    <i className="fas fa-envelope"></i>
                                                    <input
                                                        type="email"
                                                        placeholder="Enter your email"
                                                        required
                                                        value={dsaForm.email}
                                                        onChange={(e) => handleDsaInputChange('email', e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>Mobile Number *</label>
                                                <div className="input-with-icon">
                                                    <i className="fas fa-phone"></i>
                                                    <input
                                                        type="tel"
                                                        placeholder="10-digit mobile number"
                                                        required
                                                        value={dsaForm.mobile}
                                                        onChange={(e) => handleDsaInputChange('mobile', e.target.value)}
                                                        maxLength="10"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>Gender *</label>
                                                <div className="gender-options-horizontal">
                                                    {['Male', 'Female', 'Other'].map((option) => (
                                                        <button
                                                            key={option}
                                                            type="button"
                                                            className={`gender-option-small ${gender === option ? 'selected' : ''}`}
                                                            onClick={() => handleGenderChange(option)}
                                                        >
                                                            {option}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Row 3: Aadhaar Number | Residence Address */}
                                        <div className="form-columns-2">
                                            <div className="form-group">
                                                <label>Aadhaar Number *</label>
                                                <div className="input-with-icon">
                                                    <i className="fas fa-address-card"></i>
                                                    <input
                                                        type="text"
                                                        placeholder="12-digit Aadhaar number"
                                                        required
                                                        maxLength="12"
                                                        value={dsaForm.aadhaar_number || ''}
                                                        onChange={(e) => handleDsaInputChange('aadhaar_number', e.target.value.replace(/\D/g, ''))}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>Residence Address *</label>
                                                <div className="input-with-icon">
                                                    <i className="fas fa-home"></i>
                                                    <textarea
                                                        placeholder="Enter your complete residential address"
                                                        required
                                                        value={dsaForm.address}
                                                        onChange={(e) => handleDsaInputChange('address', e.target.value)}
                                                        rows="2"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Row 4: Pincode | City */}
                                        <div className="form-columns-2">
                                            <div className="form-group">
                                                <label>Pincode *</label>
                                                <div className="input-with-icon">
                                                    <i className="fas fa-map-pin"></i>
                                                    <input
                                                        type="text"
                                                        placeholder="6-digit pincode"
                                                        required
                                                        maxLength="6"
                                                        value={dsaForm.pincode}
                                                        onChange={handlePincodeChange}
                                                        onBlur={handlePincodeBlur}
                                                    />
                                                    {isLoadingLocation && (
                                                        <span className="loading-spinner">
                                                            <i className="fas fa-spinner fa-spin"></i>
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>City</label>
                                                <div className="input-with-icon">
                                                    <i className="fas fa-city"></i>
                                                    <input
                                                        type="text"
                                                        placeholder="Auto-filled from pincode"
                                                        value={dsaForm.city}
                                                        onChange={(e) => handleDsaInputChange('city', e.target.value)}
                                                        readOnly={!!dsaForm.pincode}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Row 5: Area / Locality | State */}
                                        <div className="form-columns-2">
                                            <div className="form-group">
                                                <label>Area / Locality</label>
                                                <div className="input-with-icon">
                                                    <i className="fas fa-location-dot"></i>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter your area or locality"
                                                        value={dsaForm.area}
                                                        onChange={(e) => handleDsaInputChange('area', e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>State</label>
                                                <div className="input-with-icon">
                                                    <i className="fas fa-flag"></i>
                                                    <input
                                                        type="text"
                                                        placeholder="Auto-filled from pincode"
                                                        value={dsaForm.state}
                                                        onChange={(e) => handleDsaInputChange('state', e.target.value)}
                                                        readOnly={!!dsaForm.pincode}
                                                    />
                                                </div>
                                            </div>
                                        </div>



                                        {/* Next Button Only */}
                                        <div className="form-actions-single">
                                            <button
                                                type="button"
                                                className="next-btn"
                                                onClick={goToNextStep}
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <i className="fas fa-spinner fa-spin"></i> Submitting...
                                                    </>
                                                ) : (
                                                    <>
                                                        Next <i className="fas fa-arrow-right"></i>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* Step 2: Professional Information */}
                                {dsaStep === 2 && (
                                    <div className="form-step">
                                        <div className="form-section-header">
                                            <h3><i className="fas fa-briefcase"></i> Professional Information</h3>
                                            <p>Tell us about your professional background</p>
                                        </div>

                                        {/* Row 1: Experience | Profession */}
                                        <div className="form-columns-2">
                                            <div className="form-group">
                                                <label>Experience (Years) *</label>
                                                <div className="select-with-icon">
                                                    <i className="fas fa-chart-line"></i>
                                                    <select
                                                        required
                                                        value={dsaForm.experience}
                                                        onChange={(e) => handleDsaInputChange('experience', e.target.value)}
                                                    >
                                                        <option value="">Select Experience</option>
                                                        <option value="0-1">0-1 years (Fresher)</option>
                                                        <option value="1-3">1-3 years</option>
                                                        <option value="3-5">3-5 years</option>
                                                        <option value="5+">5+ years (Experienced)</option>
                                                    </select>
                                                    <i className="fas fa-chevron-down select-arrow"></i>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>Current Profession *</label>
                                                <div className="select-with-icon">
                                                    <i className="fas fa-user-tie"></i>
                                                    <select
                                                        required
                                                        value={dsaForm.profession}
                                                        onChange={(e) => handleDsaInputChange('profession', e.target.value)}
                                                    >
                                                        <option value="">Select Profession</option>
                                                        <option value="banking">Banking Professional</option>
                                                        <option value="insurance">Insurance Agent</option>
                                                        <option value="real_estate">Real Estate Agent</option>
                                                        <option value="ca">Chartered Accountant</option>
                                                        <option value="business">Business Owner</option>
                                                        <option value="sales">Sales Professional</option>
                                                        <option value="other">Other</option>
                                                    </select>
                                                    <i className="fas fa-chevron-down select-arrow"></i>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Row 2: Selfie Photo | Office Photo */}
                                        <div className="form-columns-2">
                                            {/* Selfie Photo Card */}
                                            <div className="upload-card-compact">
                                                <div className="upload-icon">
                                                    <i className="fas fa-camera"></i>
                                                </div>
                                                <div className="upload-content">
                                                    <h4>Selfie Photo *</h4>
                                                    <p>Capture for identity verification</p>
                                                    <div className="upload-actions">
                                                        <button type="button" className="upload-btn" onClick={() => captureSelfie(setSelfiePhoto)}>
                                                            <i className="fas fa-camera"></i> Capture Selfie
                                                        </button>
                                                    </div>

                                                    {/* Selfie Photo Preview */}
                                                    {selfiePhoto && (
                                                        <div className="upload-preview">
                                                            <div className="preview-header">
                                                                <i className="fas fa-check-circle success-icon"></i>
                                                                <span>Selfie Photo:</span>
                                                            </div>
                                                            <div className="preview-content">
                                                                <div className="image-preview-container">
                                                                    {selfiePreviewUrl ? (
                                                                        <img
                                                                            src={selfiePreviewUrl}
                                                                            alt="Selfie Preview"
                                                                            className="preview-image"
                                                                        />
                                                                    ) : (
                                                                        <div className="file-info-only">
                                                                            <i className="fas fa-file-image"></i>
                                                                            <span>{selfiePhoto.name}</span>
                                                                            <small>({formatFileSize(selfiePhoto.size)})</small>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    className="remove-preview-btn"
                                                                    onClick={() => {
                                                                        setSelfiePreviewUrl('');
                                                                        setSelfiePhoto(null);
                                                                    }}
                                                                >
                                                                    <i className="fas fa-trash-alt"></i> Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Office Photo Card */}
                                            <div className="upload-card-compact">
                                                <div className="upload-icon">
                                                    <i className="fas fa-building"></i>
                                                </div>
                                                <div className="upload-content">
                                                    <h4>Office/Workspace Photo</h4>
                                                    <p>Optional workspace photo</p>
                                                    <div className="upload-actions">
                                                        <input
                                                            type="file"
                                                            id="officePicUpload"
                                                            accept="image/*"
                                                            style={{ display: 'none' }}
                                                            onChange={(e) => {
                                                                if (e.target.files[0]) {
                                                                    const file = e.target.files[0];
                                                                    handleFileUpload(setOfficePhoto, file, 5, 'office');

                                                                    // Create preview for office photo
                                                                    if (file.type.startsWith('image/')) {
                                                                        const reader = new FileReader();
                                                                        reader.onload = (event) => {
                                                                            setOfficePreviewUrl(event.target.result);
                                                                        };
                                                                        reader.readAsDataURL(file);
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                        <button type="button" className="upload-btn">
                                                            <label htmlFor="officePicUpload" style={{ cursor: 'pointer', margin: 0, display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                <i className="fas fa-upload"></i> Upload Photo
                                                            </label>
                                                        </button>
                                                    </div>

                                                    {/* Office Photo Preview */}
                                                    {(officePhoto || officePreviewUrl) && (
                                                        <div className="upload-preview">
                                                            <div className="preview-header">
                                                                <i className="fas fa-check-circle success-icon"></i>
                                                                <span>Office Photo:</span>
                                                            </div>
                                                            <div className="preview-content">
                                                                <div className="image-preview-container">
                                                                    {officePreviewUrl ? (
                                                                        <img
                                                                            src={officePreviewUrl}
                                                                            alt="Office Photo Preview"
                                                                            className="preview-image"
                                                                        />
                                                                    ) : officePhoto ? (
                                                                        <div className="file-info-only">
                                                                            <i className="fas fa-file-image"></i>
                                                                            <span>{officePhoto.name}</span>
                                                                            <small>({formatFileSize(officePhoto.size)})</small>
                                                                        </div>
                                                                    ) : null}
                                                                </div>
                                                                <button
                                                                    type="button"
                                                                    className="remove-preview-btn"
                                                                    onClick={() => {
                                                                        setOfficePreviewUrl('');
                                                                        setOfficePhoto(null);
                                                                    }}
                                                                >
                                                                    <i className="fas fa-trash-alt"></i> Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Navigation Buttons */}
                                        <div className="form-actions">
                                            <button type="button" className="prev-btn" onClick={goToPrevStep}>
                                                <i className="fas fa-arrow-left"></i> Previous
                                            </button>
                                            <button
                                                type="button"
                                                className="next-btn"
                                                onClick={goToNextStep}
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <i className="fas fa-spinner fa-spin"></i> Submitting...
                                                    </>
                                                ) : (
                                                    <>
                                                        Next <i className="fas fa-arrow-right"></i>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* Step 3: Documents */}
                                {dsaStep === 3 && (
                                    <div className="form-step">
                                        <div className="form-section-header">
                                            <h3><i className="fas fa-file-alt"></i> Required Documents</h3>
                                            <p>Upload necessary documents for verification</p>
                                        </div>

                                        {/* Aadhaar Front & Back */}
                                        <div className="form-columns">
                                            {/* Aadhaar Front */}
                                            <div className="upload-card">
                                                <div className="upload-icon">
                                                    <i className="fas fa-address-card"></i>
                                                </div>
                                                <div className="upload-content">
                                                    <h4>Aadhaar Front *</h4>
                                                    <p>Upload front side of Aadhaar card</p>
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleFileUpload(setAadhaarFront, e.target.files[0])}
                                                        id="aadhaarFrontInput"
                                                    />
                                                </div>
                                                {/* Aadhaar Front Preview */}
                                                {aadhaarFront && (
                                                    <div className="document-preview">
                                                        <div className="preview-header">
                                                            <i className="fas fa-check-circle success-icon"></i>
                                                            <span>Aadhaar Front Preview:</span>
                                                        </div>
                                                        <div className="preview-content">
                                                            {aadhaarFront.type.startsWith('image/') ? (
                                                                <div className="image-preview-container">
                                                                    <img
                                                                        src={URL.createObjectURL(aadhaarFront)}
                                                                        alt="Aadhaar Front Preview"
                                                                        className="document-preview-image"
                                                                    />
                                                                    <div className="file-info">
                                                                        <span>{aadhaarFront.name}</span>
                                                                        <span>({formatFileSize(aadhaarFront.size)})</span>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="pdf-preview">
                                                                    <i className="fas fa-file-pdf pdf-icon"></i>
                                                                    <div className="file-info">
                                                                        <span>{aadhaarFront.name}</span>
                                                                        <span>({formatFileSize(aadhaarFront.size)})</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <button
                                                                type="button"
                                                                className="remove-preview-btn"
                                                                onClick={() => setAadhaarFront(null)}
                                                            >
                                                                <i className="fas fa-trash-alt"></i> Remove
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Aadhaar Back */}
                                            <div className="upload-card">
                                                <div className="upload-icon">
                                                    <i className="fas fa-address-card"></i>
                                                </div>
                                                <div className="upload-content">
                                                    <h4>Aadhaar Back *</h4>
                                                    <p>Upload back side of Aadhaar card</p>
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleFileUpload(setAadhaarBack, e.target.files[0])}
                                                        id="aadhaarBackInput"
                                                    />
                                                </div>
                                                {/* Aadhaar Back Preview */}
                                                {aadhaarBack && (
                                                    <div className="document-preview">
                                                        <div className="preview-header">
                                                            <i className="fas fa-check-circle success-icon"></i>
                                                            <span>Aadhaar Back Preview:</span>
                                                        </div>
                                                        <div className="preview-content">
                                                            {aadhaarBack.type.startsWith('image/') ? (
                                                                <div className="image-preview-container">
                                                                    <img
                                                                        src={URL.createObjectURL(aadhaarBack)}
                                                                        alt="Aadhaar Back Preview"
                                                                        className="document-preview-image"
                                                                    />
                                                                    <div className="file-info">
                                                                        <span>{aadhaarBack.name}</span>
                                                                        <span>({formatFileSize(aadhaarBack.size)})</span>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="pdf-preview">
                                                                    <i className="fas fa-file-pdf pdf-icon"></i>
                                                                    <div className="file-info">
                                                                        <span>{aadhaarBack.name}</span>
                                                                        <span>({formatFileSize(aadhaarBack.size)})</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <button
                                                                type="button"
                                                                className="remove-preview-btn"
                                                                onClick={() => setAadhaarBack(null)}
                                                            >
                                                                <i className="fas fa-trash-alt"></i> Remove
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* PAN Card & Cancel Cheque */}
                                        <div className="form-columns">
                                            {/* PAN Card */}
                                            <div className="upload-card">
                                                <div className="upload-icon">
                                                    <i className="fas fa-id-card"></i>
                                                </div>
                                                <div className="upload-content">
                                                    <h4>PAN Card *</h4>
                                                    <p>Upload PAN card photo</p>
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleFileUpload(setPanCardPhoto, e.target.files[0])}
                                                        id="panCardInput"
                                                    />
                                                </div>
                                                {/* PAN Card Preview */}
                                                {panCardPhoto && (
                                                    <div className="document-preview">
                                                        <div className="preview-header">
                                                            <i className="fas fa-check-circle success-icon"></i>
                                                            <span>PAN Card Preview:</span>
                                                        </div>
                                                        <div className="preview-content">
                                                            {panCardPhoto.type.startsWith('image/') ? (
                                                                <div className="image-preview-container">
                                                                    <img
                                                                        src={URL.createObjectURL(panCardPhoto)}
                                                                        alt="PAN Card Preview"
                                                                        className="document-preview-image"
                                                                    />
                                                                    <div className="file-info">
                                                                        <span>{panCardPhoto.name}</span>
                                                                        <span>({formatFileSize(panCardPhoto.size)})</span>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="pdf-preview">
                                                                    <i className="fas fa-file-pdf pdf-icon"></i>
                                                                    <div className="file-info">
                                                                        <span>{panCardPhoto.name}</span>
                                                                        <span>({formatFileSize(panCardPhoto.size)})</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <button
                                                                type="button"
                                                                className="remove-preview-btn"
                                                                onClick={() => setPanCardPhoto(null)}
                                                            >
                                                                <i className="fas fa-trash-alt"></i> Remove
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Cancel Cheque */}
                                            <div className="upload-card">
                                                <div className="upload-icon">
                                                    <i className="fas fa-file-invoice-dollar"></i>
                                                </div>
                                                <div className="upload-content">
                                                    <h4>Cancel Cheque *</h4>
                                                    <p>Upload a clear image of cancelled cheque</p>
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        onChange={(e) => handleFileUpload(setCancelCheque, e.target.files[0])}
                                                        id="cancelChequeInput"
                                                    />
                                                </div>
                                                {/* Cancel Cheque Preview */}
                                                {cancelCheque && (
                                                    <div className="document-preview">
                                                        <div className="preview-header">
                                                            <i className="fas fa-check-circle success-icon"></i>
                                                            <span>Cancel Cheque Preview:</span>
                                                        </div>
                                                        <div className="preview-content">
                                                            {cancelCheque.type.startsWith('image/') ? (
                                                                <div className="image-preview-container">
                                                                    <img
                                                                        src={URL.createObjectURL(cancelCheque)}
                                                                        alt="Cancel Cheque Preview"
                                                                        className="document-preview-image"
                                                                    />
                                                                    <div className="file-info">
                                                                        <span>{cancelCheque.name}</span>
                                                                        <span>({formatFileSize(cancelCheque.size)})</span>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="pdf-preview">
                                                                    <i className="fas fa-file-pdf pdf-icon"></i>
                                                                    <div className="file-info">
                                                                        <span>{cancelCheque.name}</span>
                                                                        <span>({formatFileSize(cancelCheque.size)})</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <button
                                                                type="button"
                                                                className="remove-preview-btn"
                                                                onClick={() => setCancelCheque(null)}
                                                            >
                                                                <i className="fas fa-trash-alt"></i> Remove
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Other Documents - Dynamic */}
                                        <div className="form-section-header">
                                            <h4><i className="fas fa-file-upload"></i> Other Documents</h4>
                                            <p>Add any additional documents</p>
                                        </div>

                                        {otherDocuments.map((doc, index) => (
                                            <div key={index} className="form-group other-document-row">
                                                <div className="other-document-input">
                                                    <div className="input-with-icon">
                                                        <i className="fas fa-file"></i>
                                                        <input
                                                            type="text"
                                                            placeholder="Document description (e.g., Address Proof, Income Proof)"
                                                            value={doc.text || doc}
                                                            onChange={(e) => {
                                                                const updatedDocs = [...otherDocuments];
                                                                updatedDocs[index] = {
                                                                    ...(typeof updatedDocs[index] === 'object' ? updatedDocs[index] : { text: updatedDocs[index] }),
                                                                    text: e.target.value
                                                                };
                                                                setOtherDocuments(updatedDocs);
                                                            }}
                                                        />
                                                    </div>
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf,.doc,.docx"
                                                        className="file-input"
                                                        id={`otherDoc-${index}`}
                                                        onChange={(e) => {
                                                            if (e.target.files[0]) {
                                                                const file = e.target.files[0];
                                                                const updatedDocs = [...otherDocuments];
                                                                updatedDocs[index] = {
                                                                    ...(typeof updatedDocs[index] === 'object' ? updatedDocs[index] : { text: updatedDocs[index] }),
                                                                    file: file,
                                                                    name: file.name,
                                                                    size: file.size,
                                                                    type: file.type
                                                                };
                                                                setOtherDocuments(updatedDocs);
                                                            }
                                                        }}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="upload-other-btn"
                                                        onClick={() => document.getElementById(`otherDoc-${index}`).click()}
                                                    >
                                                        <i className="fas fa-upload"></i> Choose File
                                                    </button>
                                                    {index > 0 && (
                                                        <button
                                                            type="button"
                                                            className="remove-doc-btn"
                                                            onClick={() => removeOtherDocumentField(index)}
                                                        >
                                                            <i className="fas fa-times"></i>
                                                        </button>
                                                    )}
                                                </div>

                                                {/* Other Document Preview */}
                                                {otherDocuments[index] && otherDocuments[index].file && (
                                                    <div className="document-preview other-doc-preview">
                                                        <div className="preview-header">
                                                            <i className="fas fa-check-circle success-icon"></i>
                                                            <span>Document Preview:</span>
                                                        </div>
                                                        <div className="preview-content">
                                                            {otherDocuments[index].type && otherDocuments[index].type.startsWith('image/') ? (
                                                                <div className="image-preview-container">
                                                                    <img
                                                                        src={URL.createObjectURL(otherDocuments[index].file)}
                                                                        alt="Document Preview"
                                                                        className="document-preview-image"
                                                                    />
                                                                    <div className="file-info">
                                                                        <span>{otherDocuments[index].name}</span>
                                                                        <span>({formatFileSize(otherDocuments[index].size)})</span>
                                                                    </div>
                                                                </div>
                                                            ) : otherDocuments[index].type && otherDocuments[index].type.includes('pdf') ? (
                                                                <div className="pdf-preview">
                                                                    <i className="fas fa-file-pdf pdf-icon"></i>
                                                                    <div className="file-info">
                                                                        <span>{otherDocuments[index].name}</span>
                                                                        <span>({formatFileSize(otherDocuments[index].size)})</span>
                                                                    </div>
                                                                </div>
                                                            ) : otherDocuments[index].file ? (
                                                                <div className="doc-preview">
                                                                    <i className="fas fa-file-word doc-icon"></i>
                                                                    <div className="file-info">
                                                                        <span>{otherDocuments[index].name}</span>
                                                                        <span>({formatFileSize(otherDocuments[index].size)})</span>
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                            <button
                                                                type="button"
                                                                className="remove-preview-btn"
                                                                onClick={() => {
                                                                    const updatedDocs = [...otherDocuments];
                                                                    updatedDocs[index] = updatedDocs[index].text || '';
                                                                    setOtherDocuments(updatedDocs);
                                                                }}
                                                            >
                                                                <i className="fas fa-trash-alt"></i> Remove
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ))}

                                        <button type="button" className="add-more-btn" onClick={addOtherDocumentField}>
                                            <i className="fas fa-plus"></i> Add More Documents
                                        </button>

                                        {/* Terms and Conditions */}
                                        <div className="terms-section">
                                            <div className="terms-card">
                                                <h4><i className="fas fa-file-contract"></i> Terms & Conditions</h4>
                                                <div className="terms-content">
                                                    <p>By submitting this form, you agree to:</p>
                                                    <ul>
                                                        <li>All information provided is accurate and complete</li>
                                                        <li>Undergo KYC verification process</li>
                                                        <li>Receive commission as per company policy</li>
                                                        <li>Maintain confidentiality of customer information</li>
                                                        <li>Comply with all regulatory requirements</li>
                                                    </ul>
                                                </div>
                                                <div className="checkbox-group">
                                                    <input type="checkbox" id="agreeTerms" required />
                                                    <label htmlFor="agreeTerms">
                                                        I have read and agree to the <a href="#">Terms & Conditions</a> and <a href="#">Privacy Policy</a>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Step 3 Navigation */}
                                        <div className="form-actions">
                                            <button type="button" className="prev-btn" onClick={goToPrevStep}>
                                                <i className="fas fa-arrow-left"></i> Previous
                                            </button>
                                            <button
                                                type="submit"
                                                className="submit-dsa-btn"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <i className="fas fa-spinner fa-spin"></i> Processing...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-paper-plane"></i> Submit
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* Support Note */}
                                <div className="support-note">
                                    <i className="fas fa-headset"></i>
                                    <div>
                                        <p><strong>Need Help?</strong> Our support team will contact you within 24 hours</p>
                                        <p className="support-contact">Call us: 9909002220 | Email: partner@krishnaloan.com</p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Header